const translations = window.translations = {
  ru: {
    // Логотип
    'logo_cambridge': 'КЕМБРИДЖСКАЯ',
    'logo_international': 'МЕЖДУНАРОДНАЯ',
    'logo_school': 'ШКОЛА',
    'region_russia': 'Россия',
    'region_uzbekistan': 'Узбекистан',
    'region_modal_text': 'Ваш регион определился как Россия, можете сменить его на Узбекистан.',
    'region_modal_text_uzbekistan': 'Ваш регион определился как Узбекистан, можете сменить его на Россию.',
    // Навигация
    'nav_world': 'Мир CIS',
    'nav_program': 'Программа',
    'nav_teachers': 'Преподаватели',
    'nav_admission': 'Поступление',
    'nav_cost': 'Стоимость',
    'nav_campuses': 'Кампусы',
    'nav_media': 'Youngzine Media',
    // Подменю "Мир CIS"
    'nav_world_about': 'O CIS',
    'nav_world_mission': 'Миссия и ценности',
    'nav_world_alumni': 'Ассоциация выпускников',
    'nav_world_licenses': 'Лицензии',
    'nav_world_equipment': 'Инновационное оснащение',
    'nav_world_reviews': 'Отзывы',
    'nav_world_vacancies': 'Вакансии',
    'nav_world_contacts': 'Контакты',
    'nav_world_charter': 'Устав',
    // Подменю "Программа"
    'nav_program_cambridge': 'Международная',
    'nav_program_cambridge_uz': 'Кембриджская программа',
    'nav_program_russian': 'Российская программа',
    'nav_program_russian_uz': 'Локальная программа',
    'nav_program_kindergarten': 'Детский сад',
    'nav_program_primary': 'Начальная школа',
    'nav_program_middle': 'Средняя школа',
    'nav_program_high': 'IGCSE и A-Level',
    'nav_program_elective': 'Факультативные занятия',
    'nav_program_calendar': 'Школьный календарь',
    // Подменю "Преподаватели"
    'nav_teachers_all': 'Все',
    'nav_teachers_kindergarten': 'Детский сад',
    'nav_teachers_primary': 'Начальная школа',
    'nav_teachers_middle': 'Средняя школа',
    'nav_teachers_admin': 'Администрация',
    // Подменю "Поступление"
    'nav_admission_process': 'Процесс поступления',
    'nav_admission_apply': 'Подать заявку',
    'nav_admission_testing': 'Тестирование',
    'nav_admission_documents': 'Документы',
    'nav_admission_open_days': 'День открытых дверей',
    // Подменю "Стоимость"
    'nav_cost_tuition': 'Стоимость обучения',
    'nav_cost_skolkovo': 'Сколково',
    'nav_cost_gorki': 'Горки',
    'nav_cost_moscow': 'Москва',
    'nav_cost_spb': 'Санкт-Петербург',
    'nav_cost_tashkent': 'Ташкент',
    // Подменю "Кампусы"
    'nav_campuses_all': 'Все',
    'nav_campuses_skolkovo': 'Сколково',
    'nav_campuses_gorki': 'Горки',
    'nav_campuses_moscow': 'Москва',
    'nav_campuses_spb': 'Санкт-Петербург',
    'nav_campuses_tashkent': 'Ташкент',
    // Подменю "Youngzine Media"
    'nav_media_all': 'Все записи',
    'nav_media_journal': 'Журнал Youngzine',
    'nav_media_articles': 'Статьи',
    'nav_media_news': 'Новости',
    // Шапка
    'apply': 'Заявка',
    'search_placeholder': 'Поиск по сайту',
    'menu_text': 'Меню',
    // Hero секция
    'hero_title': 'Международная школа с обучением по двум программам',
    'hero_title_mobile': 'Международная школа с обучением по двум программам',
    'hero_subtitle': 'Международное образование для детей 2.5-18 лет, не выезжая за границу',
    'hero_subtitle_uzbekistan': 'Международное образование для детей 2-18 лет, не выезжая за границу',
    'hero_slide2_title_desktop': 'Следите за новостями и событиями школы в Telegram',
    'hero_slide2_title_mobile': 'Следите за новостями и событиями школы в Telegram',
    'hero_slide2_subtitle': 'Будьте в курсе всех событий,<br />объявлений и важных новостей CIS',
    'hero_slide3_title_desktop': 'Пробные дни в CIS Сколково на специальных условиях.*',
    'hero_slide3_title_mobile': 'Пробные дни в CIS Сколково на специальных условиях.*',
    'hero_slide3_subtitle': '*Приглашаем детей от 2.5 до 6 лет! Предложение действует до 15 декабря',
    'btn_trial': 'О поступлении',
    'btn_open_days': 'Стоимость<br />обучения',
    'btn_camps': 'Отзывы о CIS',
    'btn_cost': 'Вопросы и<br />ответы',
    // Block2
    'block2_title': 'Кембриджская международная школа',
    'block2_greeting': 'Добро пожаловать в CIS!',
    'block2_text': 'Мы создаём вдохновляющую образовательную среду, где дети от 2,5 до 18 лет раскрывают свой потенциал и учатся применять знания в жизни.',
    'block2_offers': 'Наша школа предлагает:',
    'block2_item1': 'Широкий спектр программ для учеников в возрасте от 2,5 до 18 лет;',
    'block2_item2': 'Возможность взаимодействия с ровесниками из разных стран, опыт<br />международной коммуникации;',
    'block2_item3': 'Развитие soft-skills: навыков коммуникации, командной работы и<br />критического мышления.',
    'block2_carousel_item1': 'Развитие современных навыков: коммуникации, командной работы и критического мышления.',
    'block2_carousel_item2': 'Две программы обучения для детей от 2,5 до 18 лет: Международная и Российская.',
    'block2_carousel_item2_uzbekistan': 'Две программы обучения для детей от 2 до 18 лет: Кембриджская (EYFS, Primary, Secondary, A/AS-level) и Локальная',
    'block2_carousel_item3': 'Международная среда и общение со сверстниками из разных стран.',
    'block2_main': 'Наша команда преподавателей делает всё возможное, чтобы подготовить<br />детей к современным вызовам и достичь успеха в нашем переменчивом<br />мире!',
    'block2_main': 'Наша команда преподавателей помогает каждому ребёнку уверенно расти, адаптироваться к вызовам будущего и достигать успеха.',
    'block2_invitation': 'Приходите на экскурсию — будем рады знакомству!',
    'block2_jessica': 'Джесси Ричардсон',
    'block2_director': 'Директор Кампуса Москва',
    'block2_jessica_uzbekistan': 'Рунар Салимуллин',
    'block2_director_uzbekistan': 'Директор кампуса Ташкент',
    // Block3 - Форма
    'form_tour_title': 'Записаться на экскурсию',
    'form_trial_title': 'Записаться на пробный день',
    'form_apply_title': 'Подать заявку',
    'form_request_kind': 'Тип заявки',
    'form_phone': 'Телефон',
    'form_phone_placeholder': '999 999 99 99',
    'form_select_country': 'Выберите код страны',
    'form_next': 'Далее',
    'form_submit': 'Подать заявку',
    'form_alt_text': 'Также вы можете оставить заявку, позвонив по телефону',
    'form_parent_name': 'Имя и фамилия родителя',
    'form_email': 'E-mail',
    'form_child_name': 'Имя ребёнка',
    'form_child_name_placeholder': 'Введите имя ребенка',
    'form_birth_date': 'Дата рождения ребёнка',
    'form_campus': 'Кампус CIS',
    // Block4
    'block4_title': 'Наши кампусы',
    'block4_subtitle': 'Наши кампусы расположены в самых престижных районах Москвы, Санкт-Петербурга и Ташкента.',
    'campus_skolkovo': 'Кампус<br />Сколково',
    'campus_moscow': 'Кампус<br />Москва',
    'campus_gorki': 'Кампус<br />Горки',
    'campus_spb': 'Кампус<br />Санкт-Петербург',
    'campus_tashkent': 'Кампус<br />Ташкент',
    // Названия кампусов для селектора
    'campus_name_skolkovo': 'Сколково',
    'campus_name_moscow': 'Москва',
    'campus_name_gorki': 'Горки',
    'campus_name_spb': 'Санкт-Петербург',
    'campus_name_tashkent': 'Ташкент',
    'map_view': 'Посмотреть на карте',
    // Block5
    'block5_title': 'Фотографии кампуса',
    // Block6
    'block6_programs': 'Программы',
    'block6_graduates': 'Наши выпускники',
    'block6_graduates_item1': 'Поступают в лучшие университеты мира',
    'block6_graduates_item2': 'Получают профессиональную ориентацию и поддержку при поступлении',
    'block6_soft_skills': 'Soft skills',
    'block6_soft_skills_text': 'Развиваем основополагающие <br> навыки каждого студента',
    'block6_communication': 'Коммуникация',
    'block6_teamwork': 'Командная работа',
    'block6_critical': 'Критическое мышление',
    'block6_creativity': 'Креативность',
    // Block7
    'block7_title': 'Скачать брошюру',
    'block7_name': 'Имя, Фамилия',
    'block7_name_placeholder': 'Имя Фамилия',
    'block7_phone': 'Телефон',
    'block7_email': 'E-mail',
    'block7_email_placeholder': 'example@email.com',
    'block7_campus': 'Кампус',
    'block7_download': 'Скачать',
    'block7_note': 'Подробнее о программе, команде педагогов, кружках и стоимости - в брошюре CIS',
    'block7_note_mobile': 'Подробнее о программе, команде педагогов, кружках и стоимости - в брошюре CIS',
    // Block8
    'block8_title': 'Программа обучения',
    'block8_text': 'Школа готовит выпускников по международным<br>стандартам IGCSE и A-level. Дипломы признаются престижными университетами по всему миру',
    'block8_text_uzbekistan': 'Школа готовит выпускников по международным<br>стандартам Cambridge IGCSE и A-level. Дипломы<br>признаются престижными университетами по всему миру',
    'card_kindergarten': 'Детский <br> сад',
    'card_primary': 'Начальная <br> школа',
    'card_middle': 'Средняя <br> школа',
    'card_high': 'Старшая <br> школа',
    'program_british': 'Британская <br> национальная <br> программа',
    'program_cambridge': 'Кембриджская <br> программа',
    'age_3_5': '2.5-5 лет',
    'age_5_11': '5-11 лет',
    'age_11_14': '11-16 лет',
    'age_14_18': '16-18 лет',
    'program_subtitle_kindergarten': 'Детский <br> сад',
    'program_subtitle_primary': 'Начальная <br> школа',
    'program_subtitle_middle': 'Средняя <br> школа',
    'program_subtitle_high': 'Старшая <br> школа',
    'program_title_kindergarten': 'Международная <br> программа <br> «Early Years»',
    'program_title_primary': 'Международная и <br> российская </br> программа',
    'program_title_middle': 'Международная и <br> российская </br> программа',
    'program_title_high': 'Международная <br> «A-level» и<br />российская </br> программа',
    // Узбекская версия программ (для региона Узбекистан)
    'program_title_kindergarten_uzbekistan': 'Британская программа <br> «Early Years»',
    'program_title_primary_uzbekistan': '«Cambridge Primary» <br> и локальная программа',
    'program_title_middle_uzbekistan': '«Cambridge Secondary» <br> и локальная программа',
    'program_title_high_uzbekistan': '«Cambridge A/AS-level» <br> и локальная программа',
    // Block5 - campus_tabs
    'campus_tab_territory': 'Территория',
    'campus_tab_interior': 'Интерьер',
    'campus_tab_lessons': 'Уроки и кружки',
    'campus_tab_events': 'Мероприятия',
    'campus_select_placeholder': 'Выберите кампус',
    // Block6 - преимущества
    'block6_title': 'Преимущества',
    'block6_programs_title': 'Две программы',
    'block6_programs_text': 'Обучение по двум программам одновременно: Международной и Российской',
    'block6_programs_text_uzbekistan': 'Обучение по двум программам одновременно: Кембриджской и Локальной',
    'block6_programs_item1': 'английский без языкового барьера',
    'block6_programs_item2': 'аттестат об окончании школы государственного образца',
    'block6_programs_item3': 'международный сертификат A-level для поступления в зарубежные университеты',
    'block6_international_title': 'Международная среда',
    'block6_international_item1': 'Более 120 квалифицированных педагогов из разных стран мира',
    'block6_international_item2': 'Способствуем сотрудничеству с людьми разных национальных культур',
    'block6_international_item3': 'Формирование широкой картины мира',
    'block6_international_item4': 'Погружение в языковую среду',
    'block6_safety_title': 'Безопасность',
    'block6_safety_text': 'Безопасность и здоровье каждого ребенка – наш приоритет',
    'block6_safety_item1': 'Закрытая охраняемая территория',
    'block6_safety_item2': 'Внимание к каждому ученику в небольших классах',
    'block6_meals_title': 'Питание',
    'block6_meals_item1': 'Сбалансированное детское питание 3-4 раза в день (собственная кухня)',
    'block6_meals_item2': 'Качественные продукты от производителей, подтверждающих соответствие продукции стандартам «Халяль»',
    'block6_clubs_title': 'Кружки',
    'block6_clubs_text': 'В школе организовано более <br> 30 различных кружков',
    'block6_clubs_text_uzbekistan': 'В школе организовано более <br> 70 различных кружков',
    'block6_clubs_item1': 'Гуманитарные',
    'block6_clubs_item2': 'Музыкальные',
    'block6_clubs_item3': 'Творческие',
    'block6_clubs_item4': 'Спортивные',
    'block6_clubs_item5': 'Технические',
    // Block10 - полные тексты
    'block10_title': 'Правила поступления',
    'stage1_title': 'Этап 1. Тестирование',
    'stage1_text1': 'Перед поступлением ребёнок проходит:',
    'stage1_text2': '— Тест по английскому и математике для определения уровня и подходящего класса',
    'stage1_text3': '— Собеседование с психологом, а дети до 10 лет - также с логопедом.',
    'stage1_text4': 'Родители получают рекомендации и обратную связь специалистов.',
    'stage1_text5': 'Стоимость:',
    'stage1_text6': '—  Москва, МО, Санкт-Петербург — 15 000 ₽',
    'stage1_text6_uzbekistan': '—  Ташкент — 750 000 UZS',
    'stage1_text7': 'Как проходит тестирование',
    'stage1_text8': 'Мы используем авторскую методику: процесс проходит в комфортной игровой форме. Специалист определяет уровень подготовки, навыки и особенности ребёнка.',
    'stage1_text9': 'Это помогает родителям лучше понять ребёнка, а педагогам - выстроить оптимальную траекторию обучения.',
    'stage2_title': 'Этап 2. Приём',
    'stage2_text1': 'Бронирование места: после тестирования родители заполняют анкеты и оплачивают вступительный взнос.',
    'stage2_text2': 'Сроки поступления: большинство учеников зачисляются весной и летом, поступление в течение учебного года возможно при наличии свободных мест.',
    'stage3_title': 'Этап 3. Документы',
    'stage3_header1': 'Необходимо предоставить:',
    'stage3_list1_1': 'свидетельство о рождении ребёнка;',
    'stage3_list1_2': 'паспорт ребёнка (с 14 лет) и визу - для иностранных граждан;',
    'stage3_list1_3': 'паспорт одного из родителей и визу - для иностранных граждан;',
    'stage3_list1_4': 'медицинскую карту и страховой полис;',
    'stage3_list1_5': 'академические справки из предыдущих учебных заведений;',
    'stage3_list1_6': '2 фотографии ребёнка 3×4 см;',
    'stage3_list1_7': '1 фотографию 3×4 см ответственного лица (возможно указать до 5 человек).',
    'stage3_header2': 'Важно:',
    'stage3_list2_1': 'копии всех документов можно сделать в офисе школы;',
    'stage3_list2_2': 'анкету родители получают в офисе CIS.',
    'stage3_header3': 'Контакты:',
    'stage3_text_contacts': 'подробную информацию можно получить у менеджера по приёму или электронной почте кампуса.',
    'block10_footer': 'Для знакомства с Кембриджской Международной Школой мы предлагаем всем родителям посетить нашу школу.',
    // Block11 - форма тестирования
    'form_testing_title': 'Записаться на тестирование',
    // Block16 - форма консультации
    'form_consultation_title': 'Получить консультацию',
    // Block12
    'block12_title': 'Стоимость обучения',
    'block12_info': 'Стоимость обучения зависит от даты оплаты и выбранного кампуса. Предусмотрена система скидок. Также при поступлении единовременно оплачивается вступительный взнос на семью вне зависимости от количества детей. Взнос включает все административные сборы, оплачивается один раз при поступлении и не подлежит возврату.',
    'block12_info_header1': 'Стоимость зависит от:',
    'block12_info_list1_1': 'возраста ребёнка',
    'block12_info_list1_2': 'выбранного кампуса',
    'block12_info_list1_3': 'раннего бронирования',
    'block12_info_header2': 'Обратите внимание:',
    'block12_info_list2_1': 'взимается единовременный вступительный взнос',
    'block12_info_list2_2': 'размер взноса не зависит от количества детей в семье',
    'block12_info_list2_3': 'оплачивается один раз при зачислении и не подлежит возврату',
    'block12_category_kindergarten': 'Детский сад',
    'block12_category_school': 'Школа',
    'block12_campus_skolkovo': 'Кампус<br>Сколково',
    'block12_campus_moscow': 'Кампус<br>Москва',
    'block12_campus_gorki': 'Кампус<br>Горки',
    'block12_campus_spb': 'Кампус<br>Санкт-Петербург',
    'block12_campus_tashkent': 'Кампус<br>Ташкент',
    'block12_price_info_text': 'Стоимость обучения</br>зависит от даты</br>оплаты. Предусмотрена</br>система скидок.',
    'block12_price_info_btn_more': 'Подробнее',
    'block12_price_info_btn_year': '2026-2027 год',
    'block12_year': 'год',
    'block12_years': 'лет',
    'block12_price_discount_date_before': 'до 30 Июня',
    'block12_price_discount_date_after': 'с 30 Июня',
    'block12_price_discount_date_after_july': 'с 1 Июля',
    'block12_price_kindergarten': 'Детский сад</br>Early Years',
    'block12_price_primary_ks1': 'Начальная</br>школа KS1-KS2',
    'block12_price_primary_ks2': 'Начальная</br>школа KS2',
    'block12_price_middle_ks3': 'Средняя школа</br>KS3',
    'block12_price_middle_ks4': 'Средняя школа</br>KS4',
    'block12_price_high': 'Старшая</br>школа',
    // Block14 - Наша команда
    'block14_title': 'Наша команда',
    'block14_subtitle': 'Международная команда педагогов-носителей поможет вашему ребёнку раскрыть способности и развиваться в атмосфере доверия и уважения',
    'block14_btn': 'Подробнее о преподавателях',
    'block14_reviews_title': 'Что говорят наши учителя?',
    'review_expand': 'Развернуть',
    'review_collapse': 'Свернуть',
    'teacher_name_1': 'Герман Каррера',
    'teacher_position_1': 'Учитель истории',
    'teacher_name_2': 'Стюарт Макферсон',
    'teacher_position_2': 'Директор Кампуса',
    'teacher_name_3': 'Мануэла Венегас',
    'teacher_position_3': 'Учитель испанского языка',
    'teacher_name_4': 'Майкл Элмор',
    'teacher_position_4': 'Учитель математики',
    'teacher_name_5': 'Джессика Прески',
    'teacher_position_5': 'Учитель географии и экономики',
    // Отзывы для кампуса Горки (default) - порядок соответствует данным
    'review_name_1': 'Кристофер Кингшотт',
    'review_position_1': 'Директор кампуса Горки',
    'review_text_1': 'Чтобы по-настоящему вдохновить студентов, важно самому быть увлеченным предметом, поскольку этот энтузиазм может быть невероятно заразительным. Понимая интересы и антипатии учащихся и соответствующим образом адаптируя свои методы обучения, вы сможете найти с ними общий язык и дать им наилучшие шансы на успех.',
    'review_name_2': 'Мр Том Б.',
    'review_position_2': 'Учитель английского языка, Кембриджская программа',
    'review_text_2': 'Я считаю, что школьный кабинет — это площадка для творчества. Поэтому я провожу насыщенные уроки, включающие в себя прозу, поэзию и музыку. Я хочу, чтобы мои студенты развивали эмпатию, занимались самовыражением и воспринимали английский язык как мост, ведущий к пониманию мировых культур.',
    'review_name_3': 'Мс Даниэлла',
    'review_position_3': 'Учитель класса, Кембриджская программа',
    'review_text_3': 'У каждого ребенка есть врожденное стремление к знаниям, и моя обязанность как педагога - использовать различные стратегии, обеспечивающие успех каждого ученика. Я выступаю за практический подход, понимая, что ученики часто более вовлечены в процесс, когда они активно участвуют в нем - через движение, прикосновение или голосовое взаимодействие, - а не сидят пассивно с ручкой и бумагой.',
    'review_name_4': 'Мр Пол',
    'review_position_4': 'Учитель начальных классов, Международная программа',
    'review_text_4': 'Я стараюсь сделать все уроки интересными, заставляющими задуматься и в меру сложными. Я постоянно спрашиваю себя, понравился ли бы мне урок, будь я студентом. Я прилагаю много усилий для планирования качественного обучения и стараюсь обеспечить эффективную обратную связь своим ученикам. Я возлагаю большие надежды на своих учеников, а вместе с тем и ответственность за качественную работу.',
    'review_name_5': 'Мр Тим',
    'review_position_5': 'Учитель актерского мастерства и английского языка, Международная программа',
    'review_text_5': 'Я глубоко убежден в том, что образование должно основываться на ценностях, и считаю, что мой предмет — драма — играет важнейшую роль во всестороннем развитии ребенка. Я стремлюсь сделать обучение театральному искусству не только увлекательным и интересным, но и наполненным вызовами. Драма развивает навыки, которые мои ученики будут применять на протяжении всей своей жизни. Я уверен, что благодаря моим занятиям ребята становятся толерантнее, уважают различия и не боятся выражать себя.',
    'review_name_6': 'Мр Алексей',
    'review_position_6': 'Учитель математики, Международная программа',
    'review_text_6': 'Я был очарован математикой еще в самом детстве. Моя бабушка преподавала ее в школе и заражала меня любовью к своему предмету. Ее педагогическое мастерство вызывало во мне огромное восхищение. Сегодня я стараюсь следовать ее примеру и так же пламенно вдохновлять своих учеников.',
    // Отзывы для кампуса Ташкент (используются review_name_7 и выше для дополнительных отзывов)
    'review_name_7': 'Кимберли Барбер',
    'review_position_7': 'Заместитель директора по средней школе',
    'review_text_7': 'Чтобы вдохновить студентов на учебу, мы смотрим на то, как темы, которые мы изучаем, влияют на их повседневную жизнь, и подчеркиваем сходство между ними и реальной жизнью. Актуальность изучаемых тем является ключевым аспектом.',
    // Имена учителей для кампуса Горки
    'teacher_gorki_name_1': 'Кристофер Кингшотт',
    'teacher_gorki_position_1': 'Директор кампуса Горки',
    'teacher_gorki_name_2': 'Мр Джошуа',
    'teacher_gorki_position_2': 'Учитель класса, Международная программа',
    'teacher_gorki_name_3': 'Мс Даниэлла',
    'teacher_gorki_position_3': 'Учитель класса, Международная программа',
    'teacher_gorki_name_4': 'Мс Клара',
    'teacher_gorki_position_4': 'Учитель класса, Международная программа',
    'teacher_gorki_name_5': 'Мс Салиха',
    'teacher_gorki_position_5': 'Учитель начальных классов, Международная программа',
    'teacher_gorki_name_6': 'Мр Мариус',
    'teacher_gorki_position_6': 'Учитель гуманитарных наук, Международная программа',
    'teacher_gorki_name_7': 'Мс Аманда',
    'teacher_gorki_position_7': 'Учитель актерского мастерства и математики, Международная программа',
    'teacher_gorki_name_8': 'Мр Чарльз',
    'teacher_gorki_position_8': 'Учитель естественных наук, Международная программа',
    'teacher_gorki_name_9': 'Мс Екатерина',
    'teacher_gorki_position_9': 'Координатор российской программы, учитель начальных классов',
    'teacher_gorki_name_10': 'Мс Анна',
    'teacher_gorki_position_10': 'Учитель класса, Международная программа',
    // Имена учителей для кампуса Ташкент
    'teacher_tashkent_name_1': 'Рунар Салимуллин',
    'teacher_tashkent_position_1': 'Директор кампуса Ташкент',
    'teacher_tashkent_name_2': 'Кимберли Барбер',
    'teacher_tashkent_position_2': 'Заместитель директора по средней школе',
    'teacher_tashkent_name_3': 'Кобус Стэндер',
    'teacher_tashkent_position_3': 'Заместитель директора по начальной школе',
    'teacher_tashkent_name_4': 'Елена Каневец',
    'teacher_tashkent_position_4': 'Учитель изобразительного искусства',
    'teacher_tashkent_name_5': 'Мс Дженнилин',
    'teacher_tashkent_position_5': 'Заместитель директора по детскому саду и начальной школе',
    'teacher_tashkent_name_6': 'Мр Жереми',
    'teacher_tashkent_position_6': 'Учитель класса, Международная программа',
    'teacher_tashkent_name_7': 'Мартина Каспарова',
    'teacher_tashkent_position_7': 'Учитель класса, Международная программа',
    'teacher_tashkent_name_8': 'Скотт Маклауд',
    'teacher_tashkent_position_8': 'Учитель класса, Международная программа',
    'teacher_tashkent_name_9': 'Кристофер Левер',
    'teacher_tashkent_position_9': 'Учитель класса, Международная программа',
    'teacher_tashkent_name_10': 'Дженнифер Саммерхайес',
    'teacher_tashkent_position_10': 'Учитель класса, Международная программа',
    // Block15 - Наши выпускники
    'block15_title': 'Наши выпускники',
    // Десктопный текст (769px+)
    'block15_description': 'Выпускники CIS поступают в престижные университеты России, Европы и Азии.<br><br>Двойная образовательная программа помогает:<br><br><span class="block15_dash">—</span> выбрать подходящую страну и формат обучения;<br><span class="block15_dash">—</span> соответствовать требованиям разных вузов.',
    'block15_description_mobile_uzbekistan': 'Выпускники CIS поступают в престижные университеты Европы, США, Канады и стран Азии.<br><br>Двойная образовательная программа помогает:<br><br><span class="block15_dash">—</span> выбрать подходящую страну и формат обучения;<br><span class="block15_dash">—</span> соответствовать требованиям разных вузов.',
    'block15_accordion_universities': 'Прием в университеты',
    'block15_accordion_association': 'Ассоциация выпускников',
    'block15_alumni_intro': 'Выпускники CIS (Year 11–13) поступают в университеты по всему миру благодаря сочетанию<br>локальной программы и международных экзаменов IGCSE, AS/A Level.<br><br>Более 66% выпускников продолжают обучение за рубежом.',
    // Мобильная версия контента аккордеона "Прием в университеты" (≤768px)
    'block15_alumni_intro_mobile': 'Выпускники CIS (Year 11–13) поступают в университеты по всему миру благодаря сочетанию<br>локальной программы и международных экзаменов IGCSE, AS/A Level.<br><br>Более 66% выпускников продолжают обучение за рубежом.',
    'block15_alumni_intro_mobile_uzbekistan': 'Выпускники CIS поступают в престижные университеты Европы, США, Канады и стран Азии.',
    'block15_alumni_geography_mobile': 'География поступлений:',
    'block15_alumni_geography_uk_mobile': '— Великобритания: Manchester University, University of Hull, City University London, Edinburgh Napier,<br>MetFilm School, MPW London',
    'block15_alumni_geography_usa_mobile': '— США: Worcester Polytechnic Institute, Foothill College',
    'block15_alumni_geography_russia_mobile': '— Россия: МГУ, МГИМО, ВШЭ, Финансовый университет при Правительстве РФ, СПбГУ, МИСИС',
    'block15_alumni_geography_uzbekistan_mobile': '— Узбекистан: Webster University, Inha University, New Uzbekistan University, MDIS',
    'block15_alumni_geography_uae_mobile': '— ОАЭ: Canadian University Dubai, University of Wollongong',
    'block15_alumni_geography_switzerland_mobile': '— Швейцария: University of Lausanne, International Institute Geneva, La Roche University',
    'block15_association_lead': 'Ассоциация выпускников — это сообщество выпускников CIS International School.',
    'block15_association_text_1': 'Ассоциация создана для того, чтобы выпускники поддерживали связь со своими бывшими одноклассниками и школой. Ассоциация поддерживает новых выпускников и даёт возможность укрепить дружеские и деловые отношения с людьми схожей квалификации и образования.',
    'block15_association_text_2': 'Процесс взаимодействия включает широкий набор активностей: мероприятия, присутствие в социальных сетях, программа наставничества, волонтерство и пожертвования, карьерные услуги и активное общение.',
    // Мобильная версия контента аккордеона "Ассоциация выпускников" (≤768px)
    'block15_association_mobile': 'В рамках ассоциации выпускники CIS остаются на связи, общаются, делятся опытом и<br>поддерживают друг друга после школы. Новые выпускники получают поддержку в формировании<br>дружеских и деловых связей.',
    'block15_association_formats_mobile': 'Форматы взаимодействия:',
    'block15_association_format1_mobile': '— мероприятия и встречи;',
    'block15_association_format2_mobile': '— общение в социальных сетях;',
    'block15_association_format3_mobile': '— программа наставничества;',
    'block15_association_format4_mobile': '— волонтёрство и пожертвования;',
    'block15_association_format5_mobile': '— карьерная поддержка.',
    // Страны для университетов
    'country_uk': 'Великобритания',
    'country_usa': 'США',
    'country_russia': 'Россия',
    'country_uzbekistan': 'Узбекистан',
    'country_uae': 'Объединённые Арабские Эмираты',
    'country_switzerland': 'Швейцария',
    'country_italy': 'Италия',
    'country_canada': 'Канада',
    'country_hungary': 'Венгрия',
    'country_germany': 'Германия',
    'country_netherlands': 'Нидерланды',
    'country_china': 'Китай',
    'country_finland': 'Финляндия',
    'country_poland': 'Польша',
    'country_belgium': 'Бельгия',
    // Университеты Великобритании
    'university_uk_1': 'Лондонский городской университет',
    'university_uk_2': 'Эдинбургский университет Нейпира',
    'university_uk_3': 'Школа искусств и дизайна Кингз',
    'university_uk_4': 'MetFilm School',
    'university_uk_5': 'школа MPW в Лондоне',
    'university_uk_6': 'Университет Халла',
    'university_uk_7': 'Манчестерский университет',
    // Университеты США
    'university_usa_1': 'Колледж Футхилл',
    'university_usa_2': 'Вустерский политехнический институт',
    // Университеты России
    'university_russia_1': 'Финансовый университет при Правительстве Российской Федерации',
    'university_russia_2': 'Высшая школа экономики',
    'university_russia_3': 'Международный Банковский Институт Анатолия Собчака (МБИ)',
    'university_russia_4': 'МГУ',
    'university_russia_5': 'МГИМО',
    'university_russia_6': 'МИСИС',
    'university_russia_7': 'Российский университет медицины',
    'university_russia_8': 'СПбГУ',
    // Университеты Узбекистана
    'university_uzbekistan_1': 'Центральноазиатский университет (Ташкент)',
    'university_uzbekistan_2': 'Университет Инха (Ташкент)',
    'university_uzbekistan_3': 'Сингапурский институт развития менеджмента (Ташкент)',
    'university_uzbekistan_4': 'Университет Новый Узбекистан',
    'university_uzbekistan_5': 'Университет Вебстера (Ташкенте)',
    // Университеты ОАЭ
    'university_uae_1': 'Канадский университет Дубая',
    'university_uae_2': 'Университет Вуллонгонга',
    // Университеты Швейцарии
    'university_switzerland_1': 'Международный институт в Женеве',
    'university_switzerland_2': 'Университет Ла Рош',
    'university_switzerland_3': 'Лозаннский университет',
    // Университеты Италии
    'university_italy_1': 'Свободный университет языков и коммуникаций (IULM Милан)',
    // Университеты Канады
    'university_canada_1': 'Университет Калгари',
    // Университеты Венгрии
    'university_hungary_1': 'Дебреценский университет',
    // Университеты Германии
    'university_germany_1': 'Европейский университет прикладных наук',
    // Университеты Нидерландов
    'university_netherlands_1': 'Гронингенский университет',
    // Университеты Китая
    'university_china_1': 'Гонконгский университет',
    // Университеты Финляндии
    'university_finland_1': 'Университет Тампере',
    // Университеты Польши
    'university_poland_1': 'Варшавский университет',
    // Университеты Бельгии
    'university_belgium_1': 'Брюссельский свободный университет',
    // Block19_reviews - Форма отзыва
    'block19_reviews_form_title': 'Оставить отзыв',
    'block19_reviews_form_name': 'Ваше имя',
    'block19_reviews_form_name_placeholder': 'Введите ваше имя',
    'block19_reviews_form_email': 'E-mail',
    'block19_reviews_form_email_placeholder': 'Введите ваш e-mail',
    'block19_reviews_form_rating': 'Оценка',
    'block19_reviews_form_text': 'Ваш отзыв',
    'block19_reviews_form_text_placeholder': 'Напишите ваш отзыв',
    'block19_reviews_form_submit': 'Отправить отзыв',
    'block19_reviews_form_success': 'Спасибо за ваш отзыв!',
    // Block19_reviews - Отзывы учеников
    'block19_students_reviews_title': 'Что говорят наши ученики?',
    'student_review_name_1': 'Алина',
    'student_review_year_1': 'Выпускница',
    'student_review_campus_1': 'Кампус Санкт-Петербург',
    'student_review_text_1': 'Я поступила в CIS после 9 класса, когда поняла, что хочу учиться за границей. При этом я понимала, что мой уровень английского ещё не был достаточно высоким. Поэтому мне было важно попасть в международную школу, где можно спокойно подтянуть язык и адаптироваться к новой системе обучения. Я рассматривала разные школы, но больше всего мне подошла CIS. Здесь можно учиться сразу по двум программам — международной и российской. Это было важно не только для меня, но и для моих родителей: они хотели, чтобы я сохранила знания, которые получила за девять лет в российской школе.',
    'student_review_name_2': 'Лея',
    'student_review_year_2': 'Выпускница',
    'student_review_campus_2': 'Кампус Сколково',
    'student_review_text_2': 'Мне очень помогает моя любознательность, и во многом она появилась благодаря учителям в CIS. Уже в начальной школе на уроках Science мы не просто учили теорию, а реально разбирались, как всё устроено: изучали вулканы, органы человека и проводили разные эксперименты. Даже на истории было интересно - мы строили египетские пирамиды из кубиков сахара, Великую Китайскую стену из картонных карточек, а дома викингов из винных пробок. Это было не только полезно, но и очень весело.',
    'student_review_name_3': 'Глеб',
    'student_review_year_3': 'Ученик Year 11',
    'student_review_campus_3': 'Кампус Сколково',
    'student_review_text_3': 'Я хочу заниматься биомедицинской инженерией - создавать технологии, которые помогают людям с ограниченными возможностями жить более полноценной жизнью. Школа очень помогла мне подготовиться к этому пути. Большим плюсом стало то, что в CIS есть две программы обучения. Они по-разному подходят к одним и тем же предметам и отлично дополняют друг друга. Например, на международной программе по физике мы старались понять, как и почему происходят разные явления. А на российской - учились работать с формулами и решать задачи. Хороший пример - тема передачи тепла. На международных уроках мы подробно разбирали конвекцию, теплопроводность и излучение, обсуждали их на практике. А на российских занятиях считали, сколько тепловой энергии может получить или отдать объект. В итоге сложилась цельная картина, которая действительно помогает в дальнейшем обучении.',
    // Отзывы учеников для узбекской версии (русский язык)
    'student_review_name_1_uzbekistan': 'Сайдахмадон',
    'student_review_year_1_uzbekistan': 'Ученик Year 13',
    'student_review_campus_1_uzbekistan': 'Кампус Ташкент',
    'student_review_text_1_uzbekistan': 'Многое из того, чему меня научили в CIS, я использую в обычной жизни. Здесь я научился выстраивать настоящие дружеские отношения и общаться с людьми - для меня это действительно важно.\n\nВ CIS нас также учат постоянно учиться и не бояться трудностей. Поэтому, когда что-то идёт не так, я стараюсь не переживать, а подумать, как можно решить проблему и чему она меня научит.',
    'student_review_name_2_uzbekistan': 'Сынчан',
    'student_review_year_2_uzbekistan': 'Ученик Year 13',
    'student_review_campus_2_uzbekistan': 'Кампус Ташкент',
    'student_review_text_2_uzbekistan': 'В CIS нас учат не только предметам, но и тому, как становиться лучше. Учителя здесь действительно любят своё дело и постоянно стараются делать уроки интереснее и современнее.\n\nЭто видно и за пределами классов - в школьных турнирах по волейболу и баскетболу, на дебатах, конференции MUN и других мероприятиях. В школе всегда есть возможность попробовать что-то новое и проявить себя.\n\nДля меня CIS - это не просто школа. Это место, где я стал увереннее в себе, научился работать в команде и лучше понимать других людей.',
    'student_review_name_3_uzbekistan': 'Салар',
    'student_review_year_3_uzbekistan': 'Ученик Year 11',
    'student_review_campus_3_uzbekistan': 'Кампус Ташкент',
    'student_review_text_3_uzbekistan': 'В CIS проходят международные конференции, и участие в MUN стало для меня первым таким опытом. Сначала я сильно волновался и не был уверен, что смогу уверенно чувствовать себя в такой активной обстановке.\n\nНо атмосфера оказалась очень дружелюбной. Люди вокруг поддерживали друг друга, и это помогло мне успокоиться. Со временем мне стало легче высказывать своё мнение, и я начал активно участвовать в дебатах.\n\nЯ узнал, как проходят международные конференции, научился работать в команде и увереннее общаться с другими участниками. Этот опыт помог мне познакомиться с ребятами из разных стран и почувствовать себя частью международного сообщества.',
    // Block13 - Лицензии и аккредитации
    'block13_title': 'Лицензии и аккредитации',
    'block13_card1_subtitle': 'Кембриджские международные экзамены',
    'block13_card1_info': 'Кампус Ташкент получил лицензию и может принимать Кембриджские международные экзамены и использовать Кембриджские международные программы.',
    'block13_card2_subtitle': 'The Duke of Edinburgh\'s International Award',
    'block13_card2_info': 'CIS Tashkent является лицензированной организацией и с гордостью обучает детей по международной программе развития жизненных навыков - The Duke of Edinburgh\'s International Award.',
    'block13_card3_subtitle': 'Лицензия Министерства образования Республики Узбекистан',
    'block13_card3_info': 'CIS Ташкент имеет лицензию Министерства образования Республики Узбекистан. По окончанию программы выпускники получают аттестат об окончании среднего образования.',
    'block13_download_certificate': 'Скачать сертификат',
    'block13_btn_school': 'Школа',
    'block13_btn_kindergarten': 'Детский сад',
    // Block17 - FAQ
    'block17_title': 'Часто задаваемые вопросы',
    'block17_question1': 'Что входит в стоимость обучения, а что оплачивается дополнительно?',
    'block17_answer1': 'В стоимость входит обучение по двум программам, учебные материалы, питание (3–4 раза в день), часть кружков и доступ к инфраструктуре школы. Отдельно оплачиваются школьная форма, поездки и некоторые дополнительные занятия.',
    'block17_question2': 'На каком языке ведётся обучение?',
    'block17_answer2': 'Обучение ведётся на английском языке. Русский язык изучается в рамках локальной программы — формируется билингвальная среда.',
    'block17_question3': 'Сколько детей в классе?',
    'block17_answer3': 'В CIS небольшие классы (в среднем 15–18 детей). Это позволяет уделять внимание каждому ребёнку и поддерживать индивидуальный подход.',
    'block17_question4': 'С какого возраста принимаются дети?',
    'block17_answer4': 'CIS принимает детей от 2,5 до 18 лет — от детского сада до старшей школы.',
    'block17_answer4_uzbekistan': 'CIS принимает детей от 2 до 18 лет — от детского сада до старшей школы.',
    'block17_question5': 'По какой программе происходит обучение?',
    'block17_answer5': 'В CIS реализуются две программы одновременно: международная и российская. Выпускники получают сертификат A/AS Level и государственный аттестат.',
    'block17_answer5_uzbekistan': 'В CIS реализуются две программы одновременно: Кембриджская и локальная. Выпускники получают сертификат A/AS Level и государственный аттестат.',
    'block17_question6': 'Какие дополнительные занятия и кружки есть в школе?',
    'block17_answer6': 'В CIS работает более 30 кружков: спорт, творчество, музыка, технологии и гуманитарные направления — по интересам ребёнка.',
    'block17_answer6_uzbekistan': 'В CIS работает более 70 кружков: спорт, творчество, музыка, технологии и гуманитарные направления — по интересам ребёнка.',
    'block17_question7': 'Сколько времени ребёнок находится в школе?',
    'block17_answer7': 'Учебный день длится около 7 часов и заканчивается во второй половине дня. Расписание зависит от класса. При необходимости доступна продлёнка.',
    'block17_question8': 'Есть ли домашняя работа?',
    'block17_answer8': 'Да. Домашние задания есть, их объём сбалансирован по возрасту и помогает закреплять материал и развивать самостоятельность.',
    'block17_question9': 'Есть ли продлёнка?',
    'block17_answer9': 'Да. Продлёнка включает присмотр, выполнение домашних заданий и дополнительные активности под руководством педагогов.',
    'block17_answer9_uzbekistan': 'Да. Продленка включает присмотр и дополнительные активности под руководством педагогов.',
    'block17_question10': 'Можно ли поступить в середине учебного года?',
    'block17_answer10': 'Да. В CIS можно поступить в любое время учебного года при наличии свободных мест. Основной набор проходит весной и летом.',
    'block17_question11': 'В какие вузы поступают ваши выпускники?',
    'block17_answer11': 'Выпускники CIS поступают в престижные университеты по всему миру, включая Россию, Европу, США и страны Азии. Школа оказывает сопровождение при поступлении.',
    'block17_answer11_uzbekistan': 'Выпускники CIS поступают в престижные университеты Европы, США, Канады и стран Азии. Школа оказывает сопровождение при поступлении.',
    'block17_question12': 'Какие требования к уровню английского при поступлении?',
    'block17_answer12': 'Уровень английского оценивается на вступительном тестировании. Мы принимаем детей с разным уровнем языка и помогаем им уверенно адаптироваться к обучению на английском.',
    'block17_question13': 'Как проходит адаптация ребёнка в первые недели?',
    'block17_answer13': 'Адаптация проходит поэтапно, в комфортном темпе. Педагоги внимательно наблюдают за ребёнком и помогают ему почувствовать себя уверенно с первых дней. В этот период школа поддерживает с родителями постоянную связь.',
    'block17_question14': 'Что если ребёнок заболеет в школе?',
    'block17_answer14': 'В школе работает медицинский кабинет. Мы сразу связываемся с родителями и действуем по утверждённому медицинскому протоколу.',
    // FAQ Kindergarten (Early Years page)
    'faq_kg_title': 'FAQ',
    'faq_kg_q1': 'С какого возраста вы принимаете детей?',
    'faq_kg_a1': 'Мы принимаем детей с 2,5 лет. Программы и режим дня адаптированы под индивидуальные особенности каждого ребёнка.',
    'faq_kg_a1_uz': 'Мы принимаем детей с 2 лет. Программы и режим дня адаптированы под индивидуальные особенности каждого ребёнка.',
    'faq_kg_q2': 'Как проходит адаптация?',
    'faq_kg_a2': 'Адаптация проходит постепенно и мягко, в спокойной игровой среде без стресса и давления. Родители получают регулярную обратную связь от наших специалистов.',
    'faq_kg_q3': 'Сколько длится день в детском саду?',
    'faq_kg_a3': 'День длится до 7 часов, с балансом занятий, игр, прогулок и тихого отдыха.',
    'faq_kg_q4': 'Есть ли дневной сон?',
    'faq_kg_a4': 'Да. Дневной сон по желанию и в привычном для ребёнка режиме. Часть детей отдыхает, другие занимаются спокойными играми.',
    'faq_kg_q5': 'На каком языке проходит обучение?',
    'faq_kg_a5': 'Обучение на английском по международной программе Early Years с дополнительной поддержкой развития русского языка.',
    'faq_kg_a5_uz': 'Обучение на английском по британской программе Early Years с дополнительной поддержкой развития русского языка.',
    'faq_kg_q6': 'Нужно ли ребёнку знать английский до поступления?',
    'faq_kg_a6': 'Нет. Знание английского не требуется. Дети осваивают язык естественно через игру, общение и повседневное взаимодействие с педагогами.',
    'faq_kg_q7': 'Кто работает с детьми? Есть ли носители английского?',
    'faq_kg_a7': 'С каждой группой работают три взрослых: педагог международной программы (носитель английского), русскоязычный педагог и помощник воспитателя. Это обеспечивает индивидуальное внимание и комфортную билингвальную среду.',
    'faq_kg_q8': 'Сколько детей в группе?',
    'faq_kg_a8': 'В среднем до 15 детей в группе, что позволяет создать спокойную атмосферу и индивидуальный подход.',
    'faq_kg_a8_uz': 'В среднем до 18 детей в группе, что позволяет создать спокойную атмосферу и индивидуальный подход.',
    'faq_kg_q9': 'Как обеспечивается безопасность?',
    'faq_kg_a9': 'Территория охраняемая и под наблюдением. Действует контроль доступа, дети всегда под присмотром взрослых.',
    'faq_kg_q10': 'Какое питание предусмотрено?',
    'faq_kg_a10': 'Мы предлагаем сбалансированное питание с учётом индивидуальных потребностей каждого ребёнка, включая аллергии и медицинские рекомендации.',
    'faq_kg_q11': 'Какие условия оплаты предусмотрены?',
    'faq_kg_a11': 'Мы предлагаем прозрачные и гибкие условия: оплата за год или в рассрочку. Подробности у менеджера по приёму.',
    'faq_kg_q12': 'Можно ли поступить в течение учебного года?',
    'faq_kg_a12': 'Да. Поступление в течение учебного года возможно при наличии мест в группе.',
    // Block18 - Форма вопросов
    'block18_title': 'Остались вопросы?',
    // Block19 - Новости / Статьи (на странице детского сада)
    'block19_title': 'Новости',
    'block19_articles_title': 'Статьи',
    'block19_news1_title': 'ЭКО-тренды в образовании 2025–2026: учимся спасать планету, не выходя из класса',
    'block19_news2_title': 'Социальная интеграция родителей в процесс обучения',
    'block19_news3_title': 'Частный детский сад: с какого возраста можно начать обучение',
    // Block19_reviews - Отзывы родителей
    'block19_reviews_main_title': 'Отзывы',
    'block19_reviews_title': 'Что говорят наши родители?',
    'block19_review_expand': 'Развернуть',
    'block19_review_collapse': 'Свернуть',
    'parent_review_name_1': 'Екатерина Белая',
    'parent_review_text_1': 'Лучшая школа. Две программы. Дети в результате говорят на английском, как на родном. Российская программа на хорошем уровне. Учителя требовательные, но понимающие...',
    'parent_review_name_2': 'Альбина Арбенина',
    'parent_review_text_2': 'Поступили! С нетерпением ждем 2 сентября-))) кампус отличный, кабинеты прекрасные! Надеюсь что обучение будет на высоком уровне, а гланое будет интересным.',
    'parent_review_name_3': 'Марина Воронина',
    'parent_review_text_3': 'Всё на английском языке.Даже на переменах дети общаются.Очень жёсткая дисциплина.И в то же время своеобразная свобода. Можно сидеть как угодно, задрать ноги. Учитель может есть на уроке...',
    // Отзывы для узбекской версии (русский язык)
    'parent_review_name_1_uzbekistan': 'Yunusova Sabina',
    'parent_review_text_1_uzbekistan': 'Приехала на экскурсию не предупредила заранее, они нашли время и встретили, провели по всем кабинетам, все показали, даже на уроки прям заходили, все чисто и аккуратно. После заполнения анкеты перезвонили. Сервис отличный! Девочка на ресепшене очень приветливая! Учителя восхитительные на первый взгляд, кабинеты отлично оснащены, дети бегают счастливые',
    'parent_review_name_2_uzbekistan': 'Lily Sabi',
    'parent_review_text_2_uzbekistan': 'Ребёнок учится здесь в садике. После трёх месяцев начал инициировать дома и на улице разговоры на английском, пока что с простых фраз, но и этот факт очень меня радует. Нравится, что много разнообразных кружков, начиная с 15:20 до 17:00. Подбираешь под интересы ребёнка. Есть платные и бесплатные на это время. И не надо возить дополнительно никуда. В садике постоянно много активностей.  Что-то они там рисуют, творят, в земле ковыряются, строят.  Некогда скучать. Раз в неделю ассамблея, где собираются всей младшей школой по какой-нибудь общей тематике.  Родителям присылают фото и видео в течение дня.  Приветливый персонал и учителя. Вкусное меню. Хорошие здания и оснащение кабинетов. Есть большая площадка с навесом на улице  с качелями, каруселями и тд.  Бассейна вроде бы нет. Мало бюрократии. Многие вопросы можно решить дистанционно через телеграм =) хорошая большая Парковка у садика. Нравится.  Что не надо заводить ребёнка. Переодевать и прочее.  А просто на проходной отдаёшь.  Из минусов. Все таки среда более русско говорящая: мало иностранцев. Но там где много иностранцев и ценник выше, если не в садике, то в школе точно. Так что в целом, садик при этой школе рекомендую.',
    'parent_review_name_3_uzbekistan': 'Рахимова Лазокатой',
    'parent_review_text_3_uzbekistan': 'Школа с лучшим британским образованием в Узбекистане',
    'parent_review_name_4_uzbekistan': 'Sayyora Azimova',
    'parent_review_text_4_uzbekistan': 'Отличная школа. Профессиональные педагоги. Комфортная среда для учебы. Нет буллинга.',
    // Даты для узбекской версии
    'parent_review_date_1_uzbekistan': '22 июня 2022',
    'parent_review_date_2_uzbekistan': '03 августа 2024',
    'parent_review_date_3_uzbekistan': '15 апрель 2025',
    'parent_review_date_4_uzbekistan': '25 июля 2024',
    'parent_review_name_4': 'Анна Смирнова',
    'parent_review_text_4': 'Отличная школа с высоким уровнем образования. Дети получают качественные знания и развиваются всесторонне. Учителя внимательны к каждому ученику.',
    'parent_review_name_5': 'Иван Петров',
    'parent_review_text_5': 'Хорошая школа, но есть моменты, которые можно улучшить. В целом доволен качеством образования и подходом учителей.',
    'parent_review_name_6': 'Ольга Иванова',
    'parent_review_text_6': 'Замечательная школа! Ребенок с удовольствием ходит на занятия. Атмосфера дружелюбная, учителя профессиональные. Рекомендую всем родителям.',
    // Block20 - Email рассылка
    'block20_title': 'Подпишитесь на email рассылку',
    'block20_description': 'Вас ждут полезные советы, развивающие игры для детей, интересные истории из жизни школы и приглашения на мероприятия CIS.',
    'block20_submit': 'Подписаться',
    'block20_consent': 'Нажимая на кнопку вы даёте согласие на обработку персональных данных</br>и соглашаетесь с политикой конфиденциальности',
    // Block20_campuses - Кампусы
    'block20_campus_label': 'Кампус',
    'block20_contacts_title': 'Контакты',
    'block20_contact_title_for_applicants': 'Для поступающих',
    'block20_contact_title_for_students': 'Для учащихся кампуса',
    'block20_contact_label_admissions_manager': 'Менеджер по приему',
    'block20_contact_label_campus_secretary': 'Секретарь кампуса',
    'block20_contact_label_contract_manager': 'Менеджер по договорам',
    'block20_address_title': 'Адрес',
    'block20_coordinates_title': 'Координаты',
    'block20_hours_title': 'График работы',
    'block20_hours_monday': 'Понедельник:',
    'block20_hours_tuesday': 'Вторник:',
    'block20_hours_wednesday': 'Среда:',
    'block20_hours_thursday': 'Четверг:',
    'block20_hours_friday': 'Пятница:',
    'block20_hours_saturday': 'Суббота:',
    'block20_hours_sunday': 'Воскресенье:',
    'block20_hours_closed': 'Закрыто',
    // Адреса кампусов
    'block20_address_skolkovo': '143085, Россия, МО, Одинцовский район, Заречье, Березовая ул., 1',
    'block20_address_moscow': '125565, Россия, Москва, Фестивальная ул., 7A',
    'block20_address_gorki': '143081, Россия, Московская область, Одинцовский район, деревня Солослово, коттеджный поселок «Березки»',
    'block20_address_spb': '197183, РФ, Санкт-Петербург, ул.Приморский проспект, 62 к1, стр. 1',
    'block20_address_tashkent': '100057, Узбекистан, Ташкент, Алмазарский район, улица Кичик Халка Йули, 1А',
    // Антибот
    'antibot_label': '',
    'antibot_question': 'Сколько будет {num1} - {num2}?',
    // Кнопки форм
    'form_submit_next': 'Далее',
    // Block21 - Footer
    'block21_world': 'Мир CIS',
    'block21_world_about': 'O CIS',
    'block21_world_mission': 'Миссия и ценности',
    'block21_world_alumni': 'Ассоциация выпускников',
    'block21_world_licenses': 'Лицензии',
    'block21_world_equipment': 'Инновационное оснащение',
    'block21_world_reviews': 'Отзывы',
    'block21_world_vacancies': 'Вакансии',
    'block21_world_contacts': 'Контакты',
    'block21_world_charter': 'Устав',
    'block21_program': 'Программа',
    'block21_program_cambridge': 'Международная программа',
    'block21_program_russian': 'Российская программа',
    'block21_program_cambridge_uz': 'Кембриджская программа',
    'block21_program_russian_uz': 'Локальная программа',
    'block21_program_kindergarten': 'Детский сад',
    'block21_program_primary': 'Начальная школа',
    'block21_program_middle': 'Средняя школа',
    'block21_program_high': 'IGCSE и A-level',
    'block21_program_elective': 'Факультативные занятия',
    'block21_program_calendar': 'Школьный календарь',
    'block21_teachers': 'Преподаватели',
    'block21_teachers_all': 'Все',
    'block21_teachers_kindergarten': 'Детский сад',
    'block21_teachers_primary': 'Начальная школа',
    'block21_teachers_middle': 'Средняя школа',
    'block21_teachers_admin': 'Администрация',
    'block21_admission': 'Поступление',
    'block21_admission_process': 'Процесс поступления',
    'block21_admission_apply': 'Подать заявку',
    'block21_admission_testing': 'Тестирование',
    'block21_admission_documents': 'Документы',
    'block21_admission_open_days': 'День открытых дверей',
    'block21_cost': 'Стоимость',
    'block21_cost_tuition': 'Стоимость обучения',
    'block21_campuses': 'Кампусы',
    'block21_campuses_all': 'Все',
    'block21_media': 'Youngzine Media',
    'block21_media_all': 'Все записи',
    'block21_media_journal': 'Журнал Youngzine',
    'block21_media_articles': 'Статьи',
    'block21_media_news': 'Новости',
    'block21_copyright': '© 2015-2026 CIS International School'
  },
  en: {
    // Logo
    'logo_cambridge': 'CIS',
    'logo_international': 'INTERNATIONAL',
    'logo_school': 'SCHOOL',
    'region_russia': 'Russia',
    'region_uzbekistan': 'Uzbekistan',
    'region_modal_text': 'Your region has been identified as Russia, you can change it to Uzbekistan.',
    'region_modal_text_uzbekistan': 'Your region has been identified as Uzbekistan, you can change it to Russia.',
    // Navigation
    'nav_world': 'CIS World',
    'nav_program': 'Programme',
    'nav_teachers': 'Teachers',
    'nav_admission': 'Admissions',
    'nav_cost': 'Tuition fees',
    'nav_campuses': 'Campuses',
    'nav_media': 'Youngzine Media',
    // Submenu "CIS World"
    'nav_world_about': 'About CIS',
    'nav_world_mission': 'Mission and Values',
    'nav_world_alumni': 'Alumni Association',
    'nav_world_licenses': 'Licenses',
    'nav_world_equipment': 'Innovative Equipment',
    'nav_world_reviews': 'Reviews',
    'nav_world_vacancies': 'Vacancies',
    'nav_world_contacts': 'Contacts',
    'nav_world_charter': 'Charter',
    // Submenu "Program"
    'nav_program_cambridge': 'International Programme',
    'nav_program_cambridge_uz': 'Cambridge Programme',
    'nav_program_russian': 'Russian Program',
    'nav_program_russian_uz': 'National Programme',
    'nav_program_kindergarten': 'Early Years',
    'nav_program_primary': 'Primary School',
    'nav_program_middle': 'Secondary School',
    'nav_program_high': 'IGCSE & A-Level',
    'nav_program_elective': 'Co-curricular Activities',
    'nav_program_calendar': 'School Calendar',
    // Submenu "Teachers"
    'nav_teachers_all': 'All',
    'nav_teachers_kindergarten': 'Early Years',
    'nav_teachers_primary': 'Primary School',
    'nav_teachers_middle': 'Secondary School',
    'nav_teachers_admin': 'Administration',
    // Submenu "Admission"
    'nav_admission_process': 'Admission Process',
    'nav_admission_apply': 'Apply',
    'nav_admission_testing': 'Testing',
    'nav_admission_documents': 'Documents',
    'nav_admission_open_days': 'Open Day',
    // Submenu "Cost"
    'nav_cost_tuition': 'Tuition fees',
    'nav_cost_skolkovo': 'Skolkovo',
    'nav_cost_gorki': 'Gorki',
    'nav_cost_moscow': 'Moscow',
    'nav_cost_spb': 'Saint Petersburg',
    'nav_cost_tashkent': 'Tashkent',
    // Submenu "Campuses"
    'nav_campuses_all': 'All',
    'nav_campuses_skolkovo': 'Skolkovo',
    'nav_campuses_gorki': 'Gorki',
    'nav_campuses_moscow': 'Moscow',
    'nav_campuses_spb': 'Saint Petersburg',
    'nav_campuses_tashkent': 'Tashkent',
    // Submenu "Youngzine Media"
    'nav_media_all': 'All Posts',
    'nav_media_journal': 'Youngzine Journal',
    'nav_media_articles': 'Articles',
    'nav_media_news': 'News',
    // Header
    'apply': 'Apply',
    'search_placeholder': 'Site search',
    'menu_text': 'Menu',
    // Hero section
    'hero_title': 'International school with dual-programme education',
    'hero_title_mobile': 'International school with dual-programme education',
    'hero_subtitle': 'International education for children aged 2.5-18 without leaving the country',
    'hero_subtitle_uzbekistan': 'International education for children aged 2-18 without leaving the country',
    'hero_slide2_title_desktop': 'Follow school news and events on Telegram',
    'hero_slide2_title_mobile': 'Follow school news and events on Telegram',
    'hero_slide2_subtitle': 'Stay updated on all events,<br />announcements and important CIS news',
    'hero_slide3_title_desktop': 'Trial days at CIS Skolkovo on special terms.*',
    'hero_slide3_title_mobile': 'Trial days at CIS Skolkovo on special terms.*',
    'hero_slide3_subtitle': '*We invite children from 2.5 to 6 years old! Offer valid until December 15',
    'btn_trial': 'Admissions',
    'btn_open_days': 'Tuition<br />fees',
    'btn_camps': 'Reviews about CIS',
    'btn_cost': 'Questions &<br />answers',
    // Block2
    'block2_title': 'Cambridge International School',
    'block2_greeting': 'Dear parents and students!',
    'block2_text': 'We create an inspiring learning environment where children aged 2.5 to 18 unlock their potential and learn to apply knowledge in real life.',
    'block2_offers': 'Our school offers:',
    'block2_item1': 'A wide range of programs for students aged 2.5 to 18 years;',
    'block2_item2': 'The opportunity to interact with peers from different countries, experience<br />international communication;',
    'block2_item3': 'Development of soft skills: communication, teamwork and<br />critical thinking skills.',
    'block2_carousel_item1': 'Development of modern skills: communication, teamwork and critical thinking.',
    'block2_carousel_item2': 'Two educational programs for children aged 2.5 to 18 years: International and Russian.',
    'block2_carousel_item2_uzbekistan': 'Two educational programmes for children aged 2 to 18: Cambridge (EYFS, Primary, Secondary, A/AS Level) and National.',
    'block2_carousel_item3': 'An international environment and interaction with peers from different countries',
    'block2_main': 'Our team of teachers does everything possible to prepare<br />children for modern challenges and achieve success in our ever-changing<br />world!',
    'block2_main': 'Our teaching team helps every child grow with confidence, adapt to future challenges and achieve success.',
    'block2_invitation': 'Book a campus tour - we’ll be happy to meet you!',
    'block2_jessica': 'Jessie Richardson',
    'block2_director': 'Head of School, Moscow',
    'block2_jessica_uzbekistan': 'Runar Salimullin',
    'block2_director_uzbekistan': 'Head of School, Tashkent',
    // Block3 - Form
    'form_tour_title': 'Book a campus tour',
    'form_trial_title': 'Sign up for a trial day',
    'form_apply_title': 'Apply',
    'form_request_kind': 'Request type',
    'form_phone': 'Phone',
    'form_phone_placeholder': '999 999 99 99',
    'form_select_country': 'Select country code',
    'form_next': 'Next',
    'form_submit': 'Submit application',
    'form_alt_text': 'You can also apply by calling',
    'form_parent_name': 'Parent full name',
    'form_email': 'E-mail',
    'form_child_name': 'Child name',
    'form_child_name_placeholder': 'Enter child name',
    'form_birth_date': 'Child birth date',
    'form_campus': 'CIS Campus',
    // Block4
    'block4_title': 'Our campuses',
    'block4_subtitle': 'Our campuses are located in prestigious areas of Moscow, Saint Petersburg and Tashkent',
    'campus_skolkovo': 'Skolkovo<br />Campus',
    'campus_moscow': 'Moscow<br />Campus',
    'campus_gorki': 'Gorki<br />Campus',
    'campus_spb': 'St. Petersburg<br />Campus',
    'campus_tashkent': 'Tashkent<br />Campus',
    // Campus names for selector
    'campus_name_skolkovo': 'Skolkovo',
    'campus_name_moscow': 'Moscow',
    'campus_name_gorki': 'Gorki',
    'campus_name_spb': 'St. Petersburg',
    'campus_name_tashkent': 'Tashkent',
    'campus_spb': 'Campus<br />St. Petersburg',
    'campus_tashkent': 'Campus<br />Tashkent',
    'map_view': 'View on map',
    // Block5
    'block5_title': 'Campus gallery',
    // Block6
    'block6_programs': 'Programs',
    'block6_graduates': 'Our graduates',
    'block6_graduates_item1': 'Progress to leading universities worldwide',
    'block6_graduates_item2': 'Receive professional career guidance and admissions support',
    'block6_soft_skills': 'Soft skills',
    'block6_soft_skills_text': 'We nurture essential<br> skills in every students',
    'block6_communication': 'Communication',
    'block6_teamwork': 'Teamwork',
    'block6_critical': 'Critical thinking',
    'block6_creativity': 'Creativity',
    // Block7
    'block7_title': 'Download the brochure',
    'block7_name': 'First name & last name',
    'block7_name_placeholder': 'Name Surname',
    'block7_phone': 'Phone',
    'block7_email': 'E-mail',
    'block7_email_placeholder': 'example@email.com',
    'block7_campus': 'Campus',
    'block7_download': 'Download',
    'block7_note': 'Find out more about our programmes, teaching team, co-curricular activities and fees in the CIS brochure.',
    'block7_note_mobile': 'Find out more about our programmes, teaching team, co-curricular activities and fees in the CIS brochure.',
    // Block8
    'block8_title': 'Academic programme',
    'block8_text': 'The school prepares students in line with international IGCSE and A Level standards. Our qualifications are recognized by leading universities worldwide.',
    'block8_text_uzbekistan': 'The school prepares students in line with international Cambridge IGCSE and A Level standards. Our qualifications are recognized by leading universities worldwide.',
    'card_kindergarten': 'Early <br> Years',
    'card_primary': 'Primary<br />School',
    'card_middle': 'Secondary<br />School',
    'card_high': 'Senior<br />School',
    'program_british': 'British<br />National<br />Program',
    'program_cambridge': 'Cambridge<br />Program',
    'age_3_5': 'Ages 2.5-5',
    'age_5_11': 'Ages 5-11',
    'age_11_14': 'Ages 11-16',
    'age_14_18': 'Ages 16-18',
    'program_subtitle_kindergarten': 'Early Years',
    'program_subtitle_primary': 'Primary<br />School',
    'program_subtitle_middle': 'Secondary<br />School',
    'program_subtitle_high': 'Senior <br />School',
    'program_title_kindergarten': 'International<br />«EYFS»<br />programme.',
    'program_title_primary': 'International and<br />National<br />programmes',
    'program_title_middle': 'International and<br />National<br />programmes',
    'program_title_high': 'International<br />A-level and<br />National<br />programmes',
    // Узбекская версия программ (для региона Узбекистан)
    'program_title_kindergarten_uzbekistan': 'British<br />«EYFS»<br />programme.',
    'program_title_primary_uzbekistan': 'Cambridge Primary<br />and National<br />programmes',
    'program_title_middle_uzbekistan': 'Cambridge Secondary<br />and National<br />programmes',
    'program_title_high_uzbekistan': 'Cambridge<br />«A/AS-level» and<br />National<br />programmes',
    // Block5 - campus_tabs
    'campus_tab_territory': 'Grounds',
    'campus_tab_interior': 'Interiors',
    'campus_tab_lessons': 'Classes & Clubs',
    'campus_tab_events': 'Events',
    'campus_select_placeholder': 'Select campus',
    // Block6 - advantages
    'block6_title': 'Benefits',
    'block6_programs_title': 'Two academic pathways',
    'block6_programs_text': 'Students follow two programmes in parallel: International and National:',
    'block6_programs_text_uzbekistan': 'Students follow two programmes in parallel: Cambridge and National:',
    'block6_programs_item1': 'English immersion with full academic fluency',
    'block6_programs_item2': 'National school-leaving certificate',
    'block6_programs_item3': 'International A-level qualification for entry to global universities',
    'block6_international_title': 'International learning environment',
    'block6_international_item1': 'Over 120 highly qualified teachers from around the world',
    'block6_international_item2': 'Daily collaboration with students and educators from diverse cultural backgrounds',
    'block6_international_item3': 'A broad global outlook embedded in the curriculum',
    'block6_international_item4': ' Full language immersion environment',
    'block6_safety_title': 'Safety & Wellbeing',
    'block6_safety_text': 'The safety and wellbeing of every child is our top priority',
    'block6_safety_item1': 'Secure, gated campus with controlled access',
    'block6_safety_item2': 'Individual attention of every student in small class groups',
    'block6_meals_title': 'School meals',
    'block6_meals_item1': 'Balanced, child-focused meals 3-4 times a day, prepare on-site',
    'block6_meals_item2': 'High-quality ingredients from trusted suppliers',
    'block6_meals_item3': 'Compliance with Halal food standards',
    'block6_clubs_title': 'Co-curricular Activities',
    'block6_clubs_text': 'Over 30 clubs and activities available at school:',
    'block6_clubs_text_uzbekistan': 'Over 70 clubs and activities available at school:',
    'block6_clubs_item1': 'Humanities & academic clubs',
    'block6_clubs_item2': 'Music',
    'block6_clubs_item3': 'Creative arts',
    'block6_clubs_item4': 'Sports',
    'block6_clubs_item5': 'Technology & engineering',
    // Block10 - full texts
    'block10_title': 'Admission rules',
    'stage1_title': 'Stage 1. Assessment',
    'stage1_text1': 'Before admission, each child completes:',
    'stage1_text2': 'English and Mathematics assessment to determine academic level and appropriate year group',
    'stage1_text3': 'Meeting with a school psychologist; for children under 10, this also includes a speech and language assessment',
    'stage1_text4': 'Parents receive individual feedback and professional recommendations following the assessment.',
    'stage1_text5': 'Assessment Fee:',
    'stage1_text6': 'Moscow, Moscow Region, Saint Petersburg — ₽15,000',
    'stage1_text6_uzbekistan': 'Tashkent — 750,000 UZS',
    'stage1_text7': 'How the assessment works',
    'stage1_text8': 'We use our own assessment approach, designed to be supportive and age-appropriate. The process takes place in a comfortable, child-friendly format.',
    'stage1_text9': 'Specialists assess the child\'s: academic readiness, skills and learning profile, individual needs and strengths. This helps parents better understand their child, while enabling teachers to design an optimal learning pathway.',
    'stage1_text3': 'Meeting with a school psychologist; for children under 10, this also includes a speech and language assessment',
    'stage1_text4': 'Parents receive individual feedback and professional recommendations following the assessment.',
    'stage2_title': 'Stage 2. Enrollment',
    'stage2_text1': 'Seat reservation: after testing, parents complete the application forms and pay the enrollment fee.',
    'stage2_text2': 'Admission timeline: most students enroll in spring and summer. Admission during the academic year is possible subject to availability.',
    'stage3_title': 'Stage 3. Required documents',
    'stage3_header1': 'Parents are required to submit:',
    'stage3_list1_1': 'Child\'s birth certificate;',
    'stage3_list1_2': 'Child\'s passport (from age 14) and visa - for foreign citizens;',
    'stage3_list1_3': 'Passport of one parent and visa - for foreign citizens;',
    'stage3_list1_4': 'Medical record and health insurance policy;',
    'stage3_list1_5': 'Academic transcripts from previous schools;',
    'stage3_list1_6': 'Two photographs of the child (3×4 cm);',
    'stage3_list1_7': 'One photograph (3×4 cm) of the authorized adult (up to 5 persons may be designated).',
    'stage3_header2': 'Important:',
    'stage3_list2_1': 'Copies of all documents can be made at the school office;',
    'stage3_list2_2': 'Application forms are provided at the CIS office.',
    'stage3_header3': 'Contacts:',
    'stage3_text_contacts': 'Detailed information can be obtained from the admissions manager or via the campus email.',
    'block10_footer': 'To get acquainted with Cambridge International School, we invite all parents to visit our school.',
    // Block11 - testing form
    'form_testing_title': 'Apply for an assessment',
    // Block16 - consultation form
    'form_consultation_title': 'Request a consultation',
    // Block12
    'block12_title': 'Tuition fees',
    'block12_info': 'Tuition fees depends on the payment date and selected campus. A discount system is provided. Also, upon admission, a one-time entrance fee is paid per family regardless of the number of children. The fee includes all administrative fees, is paid once upon admission and is non-refundable.',
    'block12_info_header1': 'Fees depend on:',
    'block12_info_list1_1': 'the child\'s age',
    'block12_info_list1_2': 'the selected campus',
    'block12_info_list1_3': 'early enrolment options',
    'block12_info_header2': 'Please note:',
    'block12_info_list2_1': 'a one-time enrolment fee applies',
    'block12_info_list2_2': 'the enrolment fee does not depend on the number of children in the family',
    'block12_info_list2_3': 'the fee is payable once upon enrolment and is non-refundable',
    'block12_category_kindergarten': 'Early Years',
    'block12_category_school': 'School',
    'block12_campus_skolkovo': 'Campus<br>Skolkovo',
    'block12_campus_moscow': 'Campus<br>Moscow',
    'block12_campus_gorki': 'Campus<br>Gorki',
    'block12_campus_spb': 'Campus<br>St. Petersburg',
    'block12_campus_tashkent': 'Campus<br>Tashkent',
    'block12_price_info_text': 'Tuition fees</br>depends on the payment</br>date. A discount</br>system is provided.',
    'block12_price_info_btn_more': 'More details',
    'block12_price_info_btn_year': '2026-2027 year',
    'block12_year': 'year',
    'block12_years': 'years',
    'block12_price_discount_date_before': 'until 30 June 2026',
    'block12_price_discount_date_after': 'from 30 June 2026',
    'block12_price_discount_date_after_july': 'from 1 July 2026',
    'block12_price_kindergarten': 'Early Years</br>Early Years',
    'block12_price_primary_ks1': 'Primary</br>School KS1-KS2',
    'block12_price_primary_ks2': 'Primary</br>School KS2',
    'block12_price_middle_ks3': 'Secondary School</br>KS3',
    'block12_price_middle_ks4': 'Secondary School</br>KS4',
    'block12_price_high': 'Senior</br>School',
    // Block14 - Our Team
    'block14_title': 'Our Team',
    'block14_subtitle': 'The international education program at CIS is provided by highly qualified teaching staff from the UK, Australia, Canada, USA, South Africa and other countries around the world.',
    'block14_btn': 'Learn more about teachers',
    'block14_reviews_title': 'What do our teachers say?',
    'review_expand': 'Expand',
    'review_collapse': 'Collapse',
    'teacher_name_1': 'German Carrera',
    'teacher_position_1': 'History Teacher',
    'teacher_name_2': 'Stuart McPherson',
    'teacher_position_2': 'Head of School',
    'teacher_name_3': 'Manuela Venegas',
    'teacher_position_3': 'Spanish Teacher',
    'teacher_name_4': 'Michael Elmore',
    'teacher_position_4': 'Mathematics Teacher',
    'teacher_name_5': 'Jessica Presky',
    'teacher_position_5': 'Geography and Economics Teacher',
    // Отзывы для кампуса Горки (default) - порядок соответствует данным
    'review_name_1': 'Christopher Kingshott',
    'review_position_1': 'Head of School, Gorki',
    'review_text_1': 'To truly inspire students, a teacher must be passionate about their subject - enthusiasm is contagious. Understanding students\' interests and dislikes and adapting teaching methods accordingly helps build strong connections and gives students the best chance to succeed.',
    'review_name_2': 'Mr Tom B.',
    'review_position_2': 'English Language and Literature Teacher, International Programme',
    'review_text_2': 'The classroom is a space for creativity. Through prose, poetry, and music, I encourage students to develop empathy and see English as a bridge to understanding global cultures.',
    'review_name_3': 'Ms Daniella',
    'review_position_3': 'Class Teacher, International Programme',
    'review_text_3': 'Learning is not a straight path. I design tasks suited to each student and use methods such as Total Physical Response (TPR) and experiential learning. By turning lessons into games, I create an environment where language challenges are overcome through action, collaboration, and joy.',
    'review_name_4': 'Mr Paul',
    'review_position_4': 'Primary School Teacher, International Programme',
    'review_text_4': 'I aim to make lessons engaging, thought-provoking, and appropriately challenging. I invest significant effort in planning quality learning and providing effective feedback.',
    'review_name_5': 'Mr Tim',
    'review_position_5': 'Drama and English Teacher, International Programme',
    'review_text_5': 'I strongly believe education must be values-based. Drama plays a vital role in a child\'s holistic development. It builds lifelong skills, fosters tolerance, respect for differences, and confidence in self-expression.',
    'review_name_6': 'Mr Alexey',
    'review_position_6': 'Mathematics Teacher, International Programme',
    'review_text_6': 'I fell in love with mathematics in early childhood thanks to my grandmother, a teacher herself. Today I strive to inspire my students with the same passion and dedication.',
    // Отзывы для кампуса Ташкент (используются review_name_7 и выше для дополнительных отзывов)
    'review_name_7': 'Kimberly Barber',
    'review_position_7': 'Head of Secondary School',
    'review_text_7': 'To inspire learning, we focus on how the topics we study relate to students\' everyday lives. Relevance is a key element of effective education.',
    // Имена учителей для кампуса Горки (английский)
    'teacher_gorki_name_1': 'Christopher Kingshott',
    'teacher_gorki_position_1': 'Head of School, Gorki',
    'teacher_gorki_name_2': 'Mr Joshua',
    'teacher_gorki_position_2': 'Class Teacher, International Programme',
    'teacher_gorki_name_3': 'Ms Daniella',
    'teacher_gorki_position_3': 'Class Teacher, International Programme',
    'teacher_gorki_name_4': 'Ms Clara',
    'teacher_gorki_position_4': 'Class Teacher, International Programme',
    'teacher_gorki_name_5': 'Ms Saliha',
    'teacher_gorki_position_5': 'Primary School Teacher, International Programme',
    'teacher_gorki_name_6': 'Mr Marius',
    'teacher_gorki_position_6': 'Humanities Teacher, International Programme',
    'teacher_gorki_name_7': 'Ms Amanda',
    'teacher_gorki_position_7': 'Drama and Mathematics Teacher, International Programme',
    'teacher_gorki_name_8': 'Mr Charles',
    'teacher_gorki_position_8': 'Science Teacher, International Programme',
    'teacher_gorki_name_9': 'Ms Ekaterina',
    'teacher_gorki_position_9': 'Russian Programme Coordinator, Primary School Teacher',
    'teacher_gorki_name_10': 'Ms Anna',
    'teacher_gorki_position_10': 'Class Teacher, International Programme',
    // Имена учителей для кампуса Ташкент (английский)
    'teacher_tashkent_name_1': 'Runar Salimullin',
    'teacher_tashkent_position_1': 'Head of School, Tashkent',
    'teacher_tashkent_name_2': 'Kimberly Barber',
    'teacher_tashkent_position_2': 'Head of Secondary School',
    'teacher_tashkent_name_3': 'Kobus Stander',
    'teacher_tashkent_position_3': 'Head of Primary School',
    'teacher_tashkent_name_4': 'Elena Kanevets',
    'teacher_tashkent_position_4': 'Art Teacher',
    'teacher_tashkent_name_5': 'Ms Jennilyn',
    'teacher_tashkent_position_5': 'Head of Early Years and Primary School',
    'teacher_tashkent_name_6': 'Mr Jeremy',
    'teacher_tashkent_position_6': 'Class Teacher, International Programme',
    'teacher_tashkent_name_7': 'Martina Kasparova',
    'teacher_tashkent_position_7': 'Class Teacher, International Programme',
    'teacher_tashkent_name_8': 'Scott MacLeod',
    'teacher_tashkent_position_8': 'Class Teacher, International Programme',
    'teacher_tashkent_name_9': 'Christopher Lever',
    'teacher_tashkent_position_9': 'Class Teacher, International Programme',
    'teacher_tashkent_name_10': 'Jennifer Summerhayes',
    'teacher_tashkent_position_10': 'Class Teacher, International Programme',
    // Block15 - Our Alumni
    'block15_title': 'Our graduates',
    'block15_description': 'CIS graduates enter prestigious universities in Russia, Europe and Asia.<br><br>Our dual academic pathway enables students to:<br><br><span class="block15_dash">—</span> choose the most suitable country and mode of study;<br><span class="block15_dash">—</span> meet the entry requirements of a wide range of universities.',
    'block15_description_mobile_uzbekistan': 'CIS graduates progress to leading universities in Europe, the USA, Canada and Asia.<br><br>Our dual academic pathway enables students to:<br><br><span class="block15_dash">—</span> choose the most suitable country and mode of study;<br><span class="block15_dash">—</span> meet the entry requirements of a wide range of universities.',
    'block15_accordion_universities': 'University Admissions',
    'block15_accordion_association': 'Alumni Association',
    'block15_alumni_intro': 'CIS graduates (Years 11–13) are admitted to universities worldwide thanks to the combination of the local curriculum and international examinations IGCSE, AS/A Level.<br><br>More than 66% of graduates continue their education abroad.',
    // Mobile version of accordion content "University Admissions" (≤768px)
    'block15_alumni_intro_mobile': 'CIS graduates (Years 11–13) are admitted to universities worldwide thanks to the combination of the local curriculum and international examinations IGCSE, AS/A Level.<br><br>More than 66% of graduates continue their education abroad.',
    'block15_alumni_intro_mobile_uzbekistan': 'CIS graduates are admitted to the leading universities worldwide including Europe, the USA, Canada and Asia',
    'block15_alumni_geography_mobile': 'Admission Geography:',
    'block15_alumni_geography_uk_mobile': '— United Kingdom: Manchester University, University of Hull, City University London, Edinburgh Napier, MetFilm School, MPW London',
    'block15_alumni_geography_usa_mobile': '— USA: Worcester Polytechnic Institute, Foothill College',
    'block15_alumni_geography_russia_mobile': '— Russia: Lomonosov Moscow State University, MGIMO, HSE University, Financial University under the Government of the Russian Federation, Saint Petersburg State University, MISIS',
    'block15_alumni_geography_uzbekistan_mobile': '— Uzbekistan: Webster University, Inha University, New Uzbekistan University, MDIS',
    'block15_alumni_geography_uae_mobile': '— UAE: Canadian University Dubai, University of Wollongong',
    'block15_alumni_geography_switzerland_mobile': '— Switzerland: University of Lausanne, International Institute Geneva, La Roche University',
    'block15_association_lead': 'The Alumni Association is a community of CIS International School graduates.',
    'block15_association_text_1': 'The Association was created so that graduates maintain contact with their former classmates and school. The Association supports new graduates and provides opportunities to strengthen friendly and business relationships with people of similar qualifications and education.',
    'block15_association_text_2': 'The interaction process includes a wide range of activities: events, presence on social networks, mentoring programs, volunteering and donations, career services, and active communication.',
    // Mobile version of accordion content "Alumni Association" (≤768px)
    'block15_association_mobile': 'Through the CIS alumni association graduates stay connected, share experiences, and support one another after graduation. New alumni receive support in building both personal and professional networks.',
    'block15_association_formats_mobile': 'Forms of engagement:',
    'block15_association_format1_mobile': '— events and reunions;',
    'block15_association_format2_mobile': '— communication via social networks;',
    'block15_association_format3_mobile': '— mentorship programs;',
    'block15_association_format4_mobile': '— volunteering and charitable initiatives;',
    'block15_association_format5_mobile': '— career support.',
    // Countries for universities
    'country_uk': 'United Kingdom',
    'country_usa': 'USA',
    'country_russia': 'Russia',
    'country_uzbekistan': 'Uzbekistan',
    'country_uae': 'United Arab Emirates',
    'country_switzerland': 'Switzerland',
    'country_italy': 'Italy',
    'country_canada': 'Canada',
    'country_hungary': 'Hungary',
    'country_germany': 'Germany',
    'country_netherlands': 'Netherlands',
    'country_china': 'China',
    'country_finland': 'Finland',
    'country_poland': 'Poland',
    'country_belgium': 'Belgium',
    // Universities United Kingdom
    'university_uk_1': 'City, University of London',
    'university_uk_2': 'Edinburgh Napier University',
    'university_uk_3': 'King\'s School of Arts and Design',
    'university_uk_4': 'MetFilm School',
    'university_uk_5': 'MPW School in London',
    'university_uk_6': 'University of Hull',
    'university_uk_7': 'University of Manchester',
    // Universities USA
    'university_usa_1': 'Foothill College',
    'university_usa_2': 'Worcester Polytechnic Institute',
    // Universities Russia
    'university_russia_1': 'Financial University under the Government of the Russian Federation',
    'university_russia_2': 'Higher School of Economics',
    'university_russia_3': 'Anatoly Sobchak International Banking Institute (IBI)',
    'university_russia_4': 'Moscow State University',
    'university_russia_5': 'MGIMO University',
    'university_russia_6': 'MISIS',
    'university_russia_7': 'Russian University of Medicine',
    'university_russia_8': 'Saint Petersburg State University',
    // Universities Uzbekistan
    'university_uzbekistan_1': 'Central Asian University (Tashkent)',
    'university_uzbekistan_2': 'Inha University (Tashkent)',
    'university_uzbekistan_3': 'Singapore Institute of Management Development (Tashkent)',
    'university_uzbekistan_4': 'New Uzbekistan University',
    'university_uzbekistan_5': 'Webster University (Tashkent)',
    // Universities UAE
    'university_uae_1': 'Canadian University of Dubai',
    'university_uae_2': 'University of Wollongong',
    // Universities Switzerland
    'university_switzerland_1': 'International Institute in Geneva',
    'university_switzerland_2': 'La Roche University',
    'university_switzerland_3': 'University of Lausanne',
    // Universities Italy
    'university_italy_1': 'Free University of Languages and Communication (IULM Milan)',
    // Universities Canada
    'university_canada_1': 'University of Calgary',
    // Universities Hungary
    'university_hungary_1': 'University of Debrecen',
    // Universities Germany
    'university_germany_1': 'European University of Applied Sciences',
    // Universities Netherlands
    'university_netherlands_1': 'University of Groningen',
    // Universities China
    'university_china_1': 'University of Hong Kong',
    // Universities Finland
    'university_finland_1': 'University of Tampere',
    // Universities Poland
    'university_poland_1': 'University of Warsaw',
    // Universities Belgium
    'university_belgium_1': 'Free University of Brussels',
    // Block19_reviews - Parent Reviews
    'block19_reviews_main_title': 'Parent reviews',
    'block19_reviews_title': 'What do our parents say?',
    'block19_review_expand': 'Expand',
    'block19_review_collapse': 'Collapse',
    'parent_review_name_1': 'Ekaterina Belaya',
    'parent_review_text_1': 'Best school. Two programs. Children speak English like their native language. The Russian program is at a good level. Teachers are demanding, but understanding...',
    'parent_review_name_2': 'Albina Arbenina',
    'parent_review_text_2': 'Enrolled! We are eagerly awaiting September 2nd-))) The campus is excellent, the classrooms are wonderful! I hope the education will be high-level, and most importantly, interesting.',
    'parent_review_name_3': 'Marina Voronina',
    'parent_review_text_3': 'Everything is in English. Even during breaks, children communicate. Very strict discipline. And at the same time, a peculiar freedom. You can sit however you want, put your feet up. The teacher can eat during class...',
    // Отзывы для узбекской версии (английский язык)
    'parent_review_name_1_uzbekistan': 'Yunusova Sabina',
    'parent_review_text_1_uzbekistan': 'I came for a tour without warning in advance, they found time and met me, showed me all the classrooms, showed everything, even went directly to the lessons, everything is clean and neat. After filling out the questionnaire, they called back. Excellent service! The girl at the reception is very friendly! Teachers are wonderful at first glance, classrooms are excellently equipped, children are running happy',
    'parent_review_name_2_uzbekistan': 'Lily Sabi',
    'parent_review_text_2_uzbekistan': 'The child studies here in kindergarten. After three months, he began to initiate conversations in English at home and on the street, albeit with simple phrases, but this fact also pleases me very much. I like that there are many different clubs, starting from 15:20 to 17:00. You choose according to your child\'s interests. There are paid and free at this time. And you don\'t need to drive anywhere else. There are constantly many activities in kindergarten. They draw something, create, dig in the ground, build. There\'s no time to be bored. Once a week there\'s an assembly where the whole elementary school gathers on some common topic. Parents are sent photos and videos during the day. Friendly staff and teachers. Tasty menu. Good buildings and classroom equipment. There\'s a large playground with a canopy outside with swings, carousels, etc. There seems to be no pool. Little bureaucracy. Many issues can be resolved remotely via Telegram =) good large Parking at the kindergarten. I like it. That you don\'t need to bring the child. Change clothes and so on. And just at the checkpoint you hand over. Of the minuses. The environment is still more Russian-speaking: few foreigners. But where there are many foreigners, the price tag is higher, if not in kindergarten, then definitely in school. So in general, I recommend the kindergarten at this school.',
    'parent_review_name_3_uzbekistan': 'Rakhimova Lazokatoy',
    'parent_review_text_3_uzbekistan': 'School with the best British education in Uzbekistan',
    'parent_review_name_4_uzbekistan': 'Sayyora Azimova',
    'parent_review_text_4_uzbekistan': 'Excellent school. Professional teachers. Comfortable environment for studying. No bullying.',
    // Даты для узбекской версии (английский язык)
    'parent_review_date_1_uzbekistan': 'June 22, 2022',
    'parent_review_date_2_uzbekistan': 'August 3, 2024',
    'parent_review_date_3_uzbekistan': 'April 15, 2025',
    'parent_review_date_4_uzbekistan': 'July 25, 2024',
    'parent_review_name_4': 'Anna Smirnova',
    'parent_review_text_4': 'Excellent school with a high level of education. Children receive quality knowledge and develop comprehensively. Teachers are attentive to each student.',
    'parent_review_name_5': 'Ivan Petrov',
    'parent_review_text_5': 'Good school, but there are moments that can be improved. Overall satisfied with the quality of education and the approach of teachers.',
    'parent_review_name_6': 'Olga Ivanova',
    'parent_review_text_6': 'Wonderful school! The child enjoys going to classes. The atmosphere is friendly, teachers are professional. I recommend it to all parents.',
    // Block20 - Email Newsletter
    'block20_title': 'Subscribe to email newsletter',
    'block20_description': 'Receive helpful parenting tips, educational games for children, inspiring stories from school life, and invitations to CIS events.',
    'block20_submit': 'Subscribe',
    'block20_consent': 'By clicking the button, you consent to the processing of personal data and agree to the privacy policy',
    // Block20_campuses - Campuses
    'block20_campus_label': 'Campus',
    'block20_contacts_title': 'Contacts',
    'block20_contact_title_for_applicants': 'For prospective families',
    'block20_contact_title_for_students': 'For current students & families',
    'block20_contact_label_admissions_manager': 'Admissions Manager',
    'block20_contact_label_campus_secretary': 'Secretary',
    'block20_contact_label_contract_manager': 'Contract manager',
    'block20_address_title': 'Address',
    'block20_coordinates_title': 'Coordinates',
    'block20_hours_title': 'Opening hours',
    'block20_hours_monday': 'Monday:',
    'block20_hours_tuesday': 'Tuesday:',
    'block20_hours_wednesday': 'Wednesday:',
    'block20_hours_thursday': 'Thursday:',
    'block20_hours_friday': 'Friday:',
    'block20_hours_saturday': 'Saturday:',
    'block20_hours_sunday': 'Sunday:',
    'block20_hours_closed': 'Closed',
    // Campus addresses
    'block20_address_skolkovo': '143085, Russia, Moscow Region, Odintsovo District, Zarechye, Berezovaya St., 1',
    'block20_address_moscow': '125565, Russia, Moscow, Festivalnaya St., 7A',
    'block20_address_gorki': '143081, Russia, Moscow Region, Odintsovo District, Soloslovo Village, Berezki Cottage Settlement',
    'block20_address_spb': '197183, Russia, Saint Petersburg, Primorsky Ave., 62, bld. 1, str. 1',
    'block20_address_tashkent': '100057, Uzbekistan, Tashkent, Almazar District, Kichik Khalka Yuli St., 1A',
    // Antibot
    'antibot_label': '',
    'antibot_question': 'What is {num1}-{num2}?',
    // Form buttons
    'form_submit_next': 'Next',
    // Block19_reviews - Review Form
    'block19_reviews_form_title': 'Leave a Review',
    'block19_reviews_form_name': 'Your Name',
    'block19_reviews_form_name_placeholder': 'Enter your name',
    'block19_reviews_form_email': 'E-mail',
    'block19_reviews_form_email_placeholder': 'Enter your e-mail',
    'block19_reviews_form_rating': 'Rating',
    'block19_reviews_form_text': 'Your Review',
    'block19_reviews_form_text_placeholder': 'Write your review',
    'block19_reviews_form_submit': 'Submit Review',
    'block19_reviews_form_success': 'Thank you for your review!',
    // Block19_reviews - Student Reviews
    'block19_students_reviews_title': 'Students’ testimonials',
    'block19_students_reviews_title_uzbekistan': 'Students’ testimonials', // Специальный ключ для узбекской версии (можно изменить при необходимости)
    'student_review_name_1': 'Alina',
    'student_review_year_1': 'Graduate',
    'student_review_campus_1': 'St. Petersburg Campus',
    'student_review_text_1': 'I enrolled at CIS after 9th grade when I realized I wanted to study abroad. At the same time, I understood that my English level was not yet high enough. Therefore, it was important for me to get into an international school where I could calmly improve my language skills and adapt to the new learning system. I considered different schools, but CIS suited me best. Here you can study under two programmes at once - international and Russian. This was important not only for me but also for my parents: they wanted me to preserve the knowledge I had gained over nine years in a Russian school.',
    'student_review_name_2': 'Leia',
    'student_review_year_2': 'Graduate',
    'student_review_campus_2': 'Skolkovo Campus',
    'student_review_text_2': 'My curiosity helps me a lot, and it largely appeared thanks to the teachers at CIS. Already in primary school, in Science lessons, we didn\'t just learn theory, but really understood how everything works: we studied volcanoes, human organs, and conducted various experiments. Even history was interesting - we built Egyptian pyramids from sugar cubes, the Great Wall of China from cardboard cards, and Viking houses from wine corks. It was not only useful but also very fun.',
    'student_review_name_3': 'Gleb',
    'student_review_year_3': 'Student Year 11',
    'student_review_campus_3': 'Skolkovo Campus',
    'student_review_text_3': 'I want to pursue biomedical engineering - creating technologies that help people with disabilities live fuller lives. The school has helped me a lot to prepare for this path. A big plus was that CIS has two learning programmes. They approach the same subjects differently and complement each other perfectly. For example, in the international programme in physics, we tried to understand how and why different phenomena occur. And in the Russian programme, we learned to work with formulas and solve problems. A good example is the topic of heat transfer. In international lessons, we discussed in detail convection, thermal conductivity, and radiation, discussing them in practice. And in Russian classes, we calculated how much thermal energy an object can receive or give away. As a result, a complete picture emerged that really helps in further learning.',
    // Student reviews for Uzbekistan (English language)
    'student_review_name_1_uzbekistan': 'Saidahmadon',
    'student_review_year_1_uzbekistan': 'Student Year 13',
    'student_review_campus_1_uzbekistan': 'Tashkent Campus',
    'student_review_text_1_uzbekistan': 'Much of what I learned at CIS, I use in everyday life. Here I learned to build real friendships and communicate with people - for me, this is really important.\n\nAt CIS, we are also taught to constantly learn and not be afraid of difficulties. Therefore, when something goes wrong, I try not to worry, but to think about how to solve the problem and what it will teach me.',
    'student_review_name_2_uzbekistan': 'Synchan',
    'student_review_year_2_uzbekistan': 'Student Year 13',
    'student_review_campus_2_uzbekistan': 'Tashkent Campus',
    'student_review_text_2_uzbekistan': 'At CIS, we are taught not only subjects but also how to become better. The teachers here truly love their work and constantly strive to make lessons more interesting and modern.\n\nThis is also evident outside the classrooms - in school volleyball and basketball tournaments, debates, MUN conferences, and other events. There is always an opportunity at school to try something new and express yourself.\n\nFor me, CIS is not just a school. It is a place where I became more confident, learned to work in a team, and better understand other people.',
    'student_review_name_3_uzbekistan': 'Salar',
    'student_review_year_3_uzbekistan': 'Student Year 11',
    'student_review_campus_3_uzbekistan': 'Tashkent Campus',
    'student_review_text_3_uzbekistan': 'International conferences are held at CIS, and participating in MUN was my first such experience. At first, I was very nervous and unsure if I could feel confident in such an active environment.\n\nBut the atmosphere turned out to be very friendly. People around supported each other, and this helped me calm down. Over time, it became easier for me to express my opinion, and I began to actively participate in debates.\n\nI learned how international conferences are held, learned to work in a team, and communicate more confidently with other participants. This experience helped me get to know people from different countries and feel part of an international community.',
    // Block13 - Licenses and Accreditations
    'block13_title': 'Licences & Accreditations',
    'block13_card1_subtitle': 'Cambridge International Examinations',
    'block13_card1_info': 'The Tashkent campus is a licensed Cambridge centre, authorised to deliver Cambridge international programmes and administer Cambridge international examinations. The Duke of Edinburgh’s International Award',
    'block13_card2_subtitle': 'The Duke of Edinburgh\'s International Award',
    'block13_card2_info': 'CIS Tashkent is a licensed Award Centre and proudly offers students the internationally recognised The Duke of Edinburgh’s International Award, supporting the development of essential life skills.',
    'block13_card3_subtitle': 'Ministry of Education Licence (Republic of Uzbekistan)',
    'block13_card3_info': 'CIS Tashkent is licensed by the Ministry of Education of the Republic of Uzbekistan. Upon completion of the programme, students receive a state-recognised secondary school certificate.',
    'block13_download_certificate': 'Download Certificate',
    'block13_btn_school': 'School',
    'block13_btn_kindergarten': 'Early Years',
    // Block17 - FAQ
    'block17_title': 'FAQ',
    'block17_question1': 'What is included in the tuition fee and what is paid separately?',
    'block17_answer1': 'Tuition includes education under two programs, learning materials, meals (3-4 times a day), selected clubs, and access to school facilities. School uniform, trips, and some additional activities are paid separately.',
    'block17_question2': 'What language is instruction conducted in?',
    'block17_answer2': 'Instruction is conducted in English. Russian is taught as part of the national curriculum, creating a bilingual learning environment.',
    'block17_question3': 'How many students are there in a class?',
    'block17_answer3': 'CIS maintains small class sizes (on average 15–18 students) to ensure individual attention and a personalized approach.',
    'block17_question4': 'What age are children admitted?',
    'block17_answer4': 'From 2.5 to 18 years',
    'block17_answer4_uzbekistan': 'From 2 to 18 years',
    'block17_question5': 'Which curriculum does the school follow?',
    'block17_answer5': 'International and Russian programs delivered simultaneously. Graduates receive A/AS Level certificates and a state diploma.',
    'block17_answer5_uzbekistan': 'Cambridge and national programmes delivered simultaneously. Graduates receive A/AS Level certificates and a state diploma.',
    'block17_question6': 'What extracurricular activities are available?',
    'block17_answer6': 'CIS offers more than 30 clubs, including sports, creative arts, music, technology, and humanities - based on students’ interests',
    'block17_answer6_uzbekistan': 'CIS offers more than 70 clubs, including sports, creative arts, music, technology, and humanities - based on students’ interests',
    'block17_question7': 'How long is the school day?',
    'block17_answer7': 'The school day lasts approximately 7 hours and ends in the afternoon. The schedule depends on the year group. After-school care is available if needed.',
    'block17_question8': 'Is there homework?',
    'block17_answer8': 'Yes. Homework is age-appropriate, balanced, and designed to reinforce learning and develop independent study skills.',
    'block17_question9': 'Is after-school care available?',
    'block17_answer9': 'Yes. After-school care includes supervision, homework support, and additional activities guided by teachers.',
    'block17_answer9_uzbekistan': 'Yes, the extended day programme includes supervised care and additional activities led by teachers.',
    'block17_question10': 'Is mid-year admission possible?',
    'block17_answer10': 'Yes. Students may enroll at any time during the academic year, subject to availability. The main intake takes place in spring and summer',
    'block17_question11': 'Which universities do CIS graduates attend?',
    'block17_answer11': 'Leading universities in Russia, Europe, the USA, and Asia. CIS provides full university admissions guidance and support',
    'block17_answer11_uzbekistan': 'Leading universities worldwide, including Europe, the USA, Canada, and Asia. CIS provides full university admissions guidance and support',
    'block17_question12': 'What level of English is required for admission?',
    'block17_answer12': 'English proficiency is assessed during entrance testing. CIS accepts students with different language levels and supports their confident adaptation to English-medium education',
    'block17_question13': 'How does the adaptation process work?',
    'block17_answer13': 'Adaptation is gradual and comfortable. Teachers closely observe students and help them feel confident from the first days. The school maintains constant communication with parents during this period',
    'block17_question14': 'What happens if a child becomes ill at school?',
    'block17_answer14': 'The school has a medical office. Parents are contacted immediately, and actions are taken according to the approved medical protocol.',
    // FAQ Kindergarten (Early Years page)
    'faq_kg_title': 'FAQ',
    'faq_kg_q1': 'From what age do you accept children?',
    'faq_kg_a1': 'We accept children from 2.5 years old. Programmes and daily routines are adapted to each child\'s individual needs.',
    'faq_kg_a1_uz': 'We accept children from 2 years old. Programmes and daily routines are adapted to each child\'s individual needs.',
    'faq_kg_q2': 'How does adaptation work?',
    'faq_kg_a2': 'Adaptation is gradual and gentle, in a calm, play-based environment without stress or pressure. Parents receive regular feedback from our specialists.',
    'faq_kg_q3': 'How long is the nursery day?',
    'faq_kg_a3': 'The nursery day lasts up to 7 hours, with a balance of learning activities, play, walks, and quiet rest time.',
    'faq_kg_q4': 'Is there a nap time?',
    'faq_kg_a4': 'Yes. Nap time is optional and follows the child\'s usual routine. Some children rest, while others enjoy quiet activities.',
    'faq_kg_q5': 'What language is used?',
    'faq_kg_a5': 'Learning takes place in English through the International Early Years programme, with additional support for Russian language development.',
    'faq_kg_a5_uz': 'Learning takes place in English through the British Early Years programme, with additional support for Russian language development.',
    'faq_kg_q6': 'Do children need English before enrolment?',
    'faq_kg_a6': 'No. No prior English is required. Children acquire the language naturally through play, communication, and daily interaction with teachers.',
    'faq_kg_q7': 'Who works with the children? Are there native English speakers?',
    'faq_kg_a7': 'Each group is supported by three adults: an international programme teacher (native English speaker), a Russian-speaking teacher, and a teaching assistant. This ensures individual attention and a comfortable bilingual environment.',
    'faq_kg_q8': 'How many children are in a group?',
    'faq_kg_a8': 'On average, up to 15 children per group, allowing for a calm atmosphere and an individual approach.',
    'faq_kg_a8_uz': 'On average, up to 18 children per group, allowing for a calm atmosphere and an individual approach.',
    'faq_kg_q9': 'How is safety ensured?',
    'faq_kg_a9': 'The nursery campus is secure and monitored. Access control is in place, and children are always under adult supervision.',
    'faq_kg_q10': 'What meals are provided?',
    'faq_kg_a10': 'We offer balanced, freshly prepared meals tailored to each child\'s individual dietary needs, including allergies and medical requirements. View menu',
    'faq_kg_q11': 'What payment options are available?',
    'faq_kg_a11': 'We offer transparent and flexible payment options: annual payment or instalments. Full details are provided by our admissions manager.',
    'faq_kg_q12': 'Can children join during the school year?',
    'faq_kg_a12': 'Yes. Enrolment during the academic year is possible, subject to availability in the group.',
    // Block18 - Questions Form
    'block18_title': 'Any questions left?',
    // Block19 - News / Articles (on kindergarten page)
    'block19_title': 'News',
    'block19_articles_title': 'Articles',
    'block19_news1_title': 'ECO trends in education 2025–2026: learning to save the planet without leaving the classroom',
    'block19_news2_title': 'Social integration of parents into the learning process',
    'block19_news3_title': 'Private Early Years: from what age can a child start education',
    // Block21 - Footer
    'block21_world': 'The CIS World',
    'block21_world_about': 'About CIS',
    'block21_world_mission': 'Mission & Values',
    'block21_world_alumni': 'Alumni Association',
    'block21_world_licenses': 'Licences',
    'block21_world_equipment': 'Innovative Facilities',
    'block21_world_reviews': 'Reviews',
    'block21_world_vacancies': 'Careers',
    'block21_world_contacts': 'Contact Us',
    'block21_world_charter': 'Charter',
    'block21_program': 'Programmes',
    'block21_program_cambridge': 'International Programme',
    'block21_program_russian': 'Russian Programme',
    'block21_program_cambridge_uz': 'Cambridge Programme',
    'block21_program_russian_uz': 'National Programme',
    'block21_program_kindergarten': 'Early Years',
    'block21_program_primary': 'Primary School',
    'block21_program_middle': 'Secondary School',
    'block21_program_high': 'IGCSE & A-level',
    'block21_program_elective': 'Co-curricular Activities',
    'block21_program_calendar': 'School Calendar',
    'block21_teachers': 'Teaching Staff',
    'block21_teachers_all': 'All',
    'block21_teachers_kindergarten': 'Early Years',
    'block21_teachers_primary': 'Primary School',
    'block21_teachers_middle': 'Secondary School',
    'block21_teachers_admin': 'Administration',
    'block21_admission': 'Admissions',
    'block21_admission_process': 'Admissions Process',
    'block21_admission_apply': 'Submit an Application',
    'block21_admission_testing': 'Assessment',
    'block21_admission_documents': 'Required Documents',
    'block21_admission_open_days': 'Open Day',
    'block21_cost': 'Fees',
    'block21_cost_tuition': 'Tuition Fees',
    'block21_campuses': 'Campuses',
    'block21_campuses_all': 'All',
    'block21_media': 'Youngzine Media',
    'block21_media_all': 'All Posts',
    'block21_media_journal': 'Youngzine Magazine',
    'block21_media_articles': 'Articles',
    'block21_media_news': 'News',
    'block21_copyright': '© 2015–2026 CIS International School'
  }
};
